// src/lib/core/navigations/index.ts
import { faChartLine, faChartSimple, faGear, faPhone } from "@oppy/omniv2-ui";
var BASE_NAVIGATIONS = [
  {
    id: "sales-compliant",
    href: "/sales-compliant/dashboard",
    label: "Conformit\xE9 des ventes",
    requiredPermission: {
      resource: "salesCompliant",
      permission: "access"
    },
    subItems: [
      {
        id: "sales-dashboard",
        href: "/sales-compliant/dashboard",
        label: "Dashboard",
        iconProps: {
          icon: faChartSimple
        }
      },
      {
        id: "sales-activity",
        href: "/sales-compliant/sales-activity",
        label: "Activit\xE9 de vente",
        iconProps: {
          icon: faPhone
        }
      },
      {
        id: "sales-settings",
        href: "/sales-compliant/settings",
        label: "Param\xE8tres",
        iconProps: {
          icon: faGear
        }
      }
    ]
  },
  {
    id: "quality-monitoring",
    href: "/quality-monitoring/dashboard",
    label: "Qualit\xE9 monitoring",
    requiredPermission: {
      resource: "qualityMonitoring",
      permission: "access"
    },
    subItems: [
      {
        id: "quality-dashboard",
        href: "/quality-monitoring/dashboard",
        label: "Dashboard",
        iconProps: {
          icon: faChartSimple
        }
      },
      {
        id: "quality-exchanges",
        href: "/quality-monitoring/exchanges",
        label: "Qualit\xE9 des \xE9changes",
        iconProps: {
          icon: faChartLine
        }
      },
      {
        id: "quality-settings",
        href: "/quality-monitoring/settings",
        label: "Param\xE8tres",
        iconProps: {
          icon: faGear
        }
      }
    ]
  }
];
var navigations_default = BASE_NAVIGATIONS;

// src/lib/core/routes/index.tsx
import { RouteGuard } from "@oppy/omniv2-core";
import { PERMISSIONS, RESOURCES } from "@oppy/omniv2-utils";
import { redirect } from "react-router-dom";

// src/pages/exchange-details/index.tsx
import { Loading as Loading4 } from "@oppy/omniv2-ui";
import { useQuery as useQuery4 } from "@tanstack/react-query";
import { useEffect as useEffect4 } from "react";
import { useNavigate, useParams as useParams2 } from "react-router-dom";

// src/lib/core/constants.ts
import {
  faCheck,
  faHourglassHalf,
  faQuestionCircle,
  faTimes
} from "@oppy/omniv2-ui";
var DEFAULT_PAGE_SIZE = 15;
var DEFAULT_PAGE_NUMBER = 1;
var SEARCH_PERIODS = [
  { key: "today", name: "Aujourd'hui" },
  { key: "yesterday", name: "Hier" },
  { key: "this-week", name: "Cette semaine" },
  { key: "last-seven-days", name: "7 derniers jours" },
  { key: "previous-week", name: "La semaine derni\xE8re" },
  { key: "this-month", name: "Ce mois-ci" },
  { key: "last-30-days", name: "30 derniers jours" },
  { key: "previous-month", name: "Le mois dernier" },
  { key: "all", name: "Toute la p\xE9riode" }
];
var DEFAULT_PERIOD = SEARCH_PERIODS[2];
var COMPUTE_PERIODS_MAPPING = {
  today: () => {
    const now = /* @__PURE__ */ new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );
    return {
      from: startOfDay,
      to: endOfDay
    };
  },
  yesterday: () => {
    const now = /* @__PURE__ */ new Date();
    const startOfYesterday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1,
      0,
      0,
      0
    );
    const endOfYesterday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1,
      23,
      59,
      59
    );
    return {
      from: startOfYesterday,
      to: endOfYesterday
    };
  },
  "this-week": () => {
    const now = /* @__PURE__ */ new Date();
    const dayOfWeek = now.getDay();
    const startOfWeek = new Date(now);
    const endOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - (dayOfWeek + 6) % 7);
    startOfWeek.setHours(0, 0, 0, 0);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);
    return {
      from: startOfWeek,
      to: endOfWeek
    };
  },
  "last-seven-days": () => {
    const now = /* @__PURE__ */ new Date();
    const startOfLastSevenDays = new Date(now);
    startOfLastSevenDays.setDate(now.getDate() - 6);
    startOfLastSevenDays.setHours(0, 0, 0, 0);
    const endOfLastSevenDays = new Date(now);
    endOfLastSevenDays.setHours(23, 59, 59, 999);
    return {
      from: startOfLastSevenDays,
      to: endOfLastSevenDays
    };
  },
  "previous-week": () => {
    const now = /* @__PURE__ */ new Date();
    const dayOfWeek = now.getDay();
    const startOfPreviousWeek = new Date(now);
    const endOfPreviousWeek = new Date(now);
    startOfPreviousWeek.setDate(now.getDate() - dayOfWeek - 7 + 1);
    startOfPreviousWeek.setHours(0, 0, 0, 0);
    endOfPreviousWeek.setDate(startOfPreviousWeek.getDate() + 6);
    endOfPreviousWeek.setHours(23, 59, 59, 999);
    return {
      from: startOfPreviousWeek,
      to: endOfPreviousWeek
    };
  },
  "this-month": () => {
    const now = /* @__PURE__ */ new Date();
    const startOfMonth = new Date(
      now.getFullYear(),
      now.getMonth(),
      1,
      0,
      0,
      0
    );
    const endOfMonth = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0,
      23,
      59,
      59
    );
    return {
      from: startOfMonth,
      to: endOfMonth
    };
  },
  "last-30-days": () => {
    const now = /* @__PURE__ */ new Date();
    const startOfLast30Days = new Date(now);
    startOfLast30Days.setDate(now.getDate() - 29);
    startOfLast30Days.setHours(0, 0, 0, 0);
    const endOfLast30Days = new Date(now);
    endOfLast30Days.setHours(23, 59, 59, 999);
    return {
      from: startOfLast30Days,
      to: endOfLast30Days
    };
  },
  "previous-month": () => {
    const now = /* @__PURE__ */ new Date();
    const startOfPreviousMonth = new Date(
      now.getFullYear(),
      now.getMonth() - 1,
      1,
      0,
      0,
      0
    );
    const endOfPreviousMonth = new Date(
      now.getFullYear(),
      now.getMonth(),
      0,
      23,
      59,
      59
    );
    return {
      from: startOfPreviousMonth,
      to: endOfPreviousMonth
    };
  },
  all: () => {
    const now = /* @__PURE__ */ new Date();
    const startOfPreviousMonth = new Date(1970, 0, 1, 0, 0, 0);
    const endOfPreviousMonth = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0,
      23,
      59,
      59
    );
    return {
      from: startOfPreviousMonth,
      to: endOfPreviousMonth
    };
  }
};
var ICON_STATUS_MAPPING = {
  Unknown: faQuestionCircle,
  TranscriptionPending: faHourglassHalf,
  TranscriptionSucceeded: faHourglassHalf,
  TranscriptionFailed: faTimes,
  EvaluationPending: faHourglassHalf,
  EvaluationSucceeded: faCheck,
  EvaluationFailed: faTimes
};
var COLOR_STATUS_MAPPING = {
  Unknown: "text-black",
  TranscriptionPending: "text-warning",
  TranscriptionSucceeded: "text-warning",
  TranscriptionFailed: "text-error",
  EvaluationPending: "text-warning",
  EvaluationSucceeded: "text-success",
  EvaluationFailed: "text-error"
};
var STATUS_TITLE_MAPPING = {
  Unknown: "",
  TranscriptionPending: "Transcription en cours",
  TranscriptionSucceeded: "Transcription termin\xE9e",
  TranscriptionFailed: "Erreur de transcription",
  EvaluationPending: "\xC9valuation en attente",
  EvaluationSucceeded: "\xC9valuation termin\xE9e",
  EvaluationFailed: "Erreur d'\xE9valuation"
};
var DEFAULT_STALE_TIME = 3e5;
var EVAL_ID_MAX_CHARS = 8;

// src/lib/core/store/evaluation-details/index.ts
import { create } from "zustand";
var DEFAULT_STATE = {
  evaluation: void 0
};
var useEvaluationDetailsStore = create((set) => ({
  ...DEFAULT_STATE,
  setEvaluation: (evaluation) => {
    set({ evaluation });
  },
  reset: () => {
    set({ ...DEFAULT_STATE });
  }
}));

// src/lib/services/evaluations.service.ts
import { omniApiClient } from "@oppy/omniv2-core";

// src/lib/services/service.helper.ts
function getBaseUrl(entityId) {
  return `${entityId}/convoanalyzer/`;
}

// src/lib/services/evaluations.service.ts
async function findEvaluationById(evaluationId, entityId) {
  return omniApiClient.get(
    `${getBaseUrl(entityId)}evaluations/${evaluationId}`
  );
}
async function findAudioByEvaluationId(evaluationId, entityId) {
  const data = await omniApiClient.get(
    `${getBaseUrl(entityId)}evaluations/${evaluationId}/file`
  );
  const binaryData = atob(data.file);
  const byteArray = Uint8Array.from(binaryData, (char) => char.charCodeAt(0));
  return new Blob([byteArray]);
}

// src/pages/exchange-details/components/back-link/index.tsx
import { AppLink, faArrowLeft, Icon } from "@oppy/omniv2-ui";

// src/lib/core/store/dialog/index.ts
import { create as create2 } from "zustand";
var useDialogStore = create2((set) => ({
  type: void 0,
  openDialog: (args) => set({ ...args }),
  closeDialog: () => set({ type: void 0, title: void 0 })
}));

// src/lib/core/store/evaluation-audio/index.ts
import { create as create3 } from "zustand";
var useEvaluationAudioStore = create3((set) => ({
  isPlaying: false,
  startPlayingTime: 0,
  currentUtteranceIndex: void 0,
  setIsPlaying: (isPlaying, startPlayingTime = 0) => {
    set({ isPlaying, startPlayingTime: isPlaying ? startPlayingTime : 0 });
  },
  setSelectedStrongMoment: (selectedStrongMoment) => {
    set({ selectedStrongMoment });
  },
  setCurrentUtteranceIndex: (currentUtterancesIndex) => {
    set({ currentUtteranceIndex: currentUtterancesIndex });
  }
}));

// src/lib/core/store/new-grid/index.ts
import { removeDuplicates } from "@oppy/omniv2-utils";
import { create as create4 } from "zustand";
var EMPTY_TAG = {
  label: "Libell\xE9",
  criteria: "Crit\xE8re",
  color: "#3BC0B0"
};
var DEFAULT_STATE2 = {
  gridType: "SalesCompliant",
  initialized: false,
  data: { phases: [], tags: [] },
  availableCategories: [],
  // flags.
  isNewPhaseModalOpen: false
};
var useNewGridStore = create4((set, get) => ({
  ...DEFAULT_STATE2,
  init: (gridType, gridToUpdate) => {
    if (!gridToUpdate) {
      set({ ...DEFAULT_STATE2, gridType, initialized: true });
      return;
    }
    const hasSegment = !!gridToUpdate.minPartialScore && !!gridToUpdate.maxPartialScore;
    const availableCategories = removeDuplicates(gridToUpdate.criteria?.map((item) => item.category)).map(
      (label) => ({ label })
    ) || [];
    set({
      ...DEFAULT_STATE2,
      gridType,
      initialized: true,
      availableCategories,
      data: {
        gridIdToUpdate: gridToUpdate.id,
        phases: gridToUpdate.criteria.map((item, index) => ({
          criteria: item.name,
          category: {
            label: item.category
          },
          maxScore: item.maxScore,
          position: index + 1,
          invalidate: item.mustBeSatisfied,
          compliant: {
            context: item.compliantReason || "",
            enabled: true
            // Missing from API.
          },
          partiallyCompliant: {
            context: item.partialReason,
            enabled: true
            // Missing from API.
          },
          nonCompliant: {
            context: item.nonCompliantReason,
            enabled: true
            // Missing from API.
          },
          nonApplicable: {
            context: item.nonApplicableReason,
            enabled: true
            // Missing from API.
          }
        })),
        tags: gridToUpdate.tags?.map((tag) => ({
          label: tag.name,
          criteria: tag.triggerCriterion,
          color: tag.color
        })) || [],
        step1: {
          gridName: gridToUpdate.name || "",
          description: gridToUpdate.description || void 0,
          summaryPrompt: gridToUpdate.summaryPrompt || void 0,
          hasSegment,
          segment: hasSegment ? {
            min: gridToUpdate.minPartialScore,
            max: gridToUpdate.maxPartialScore
          } : void 0,
          hasSummary: !!gridToUpdate.summaryPrompt
        }
      }
    });
  },
  clear: () => {
    set({ ...DEFAULT_STATE2 });
  },
  setData: (data) => set((old) => ({ data: { ...old.data, ...data } })),
  toggleNewPhaseModalOpen: (isNewPhaseModalOpen, phasePositionToEdit) => set({ isNewPhaseModalOpen, phasePositionToEdit }),
  addPhase: (newPhase) => {
    const { data, phasePositionToEdit } = get();
    let newPhases = [];
    if (phasePositionToEdit !== void 0) {
      const phase = data.phases.find(
        (item) => item.position === phasePositionToEdit
      );
      if (phase) {
        const index = data.phases.indexOf(phase);
        newPhases = [...data.phases];
        newPhases[index] = newPhase;
      }
    } else {
      newPhases = [...data.phases, newPhase];
    }
    const availableCategories = newPhases.map((item) => item.category).sort((aCategory, bCategory) => {
      if (aCategory.label < bCategory.label) return -1;
      if (aCategory.label > bCategory.label) return 1;
      return 0;
    });
    newPhases = newPhases.map((item, index) => ({
      ...item,
      // We don't want "0" as position.
      position: index + 1
    }));
    set((old) => ({
      data: { ...old.data, phases: newPhases },
      isNewPhaseModalOpen: false,
      availableCategories
    }));
  },
  removePhase: (position) => {
    const { data } = get();
    const newPhases = data.phases.filter((item) => item.position !== position).map((item, index) => ({
      ...item,
      // We don't want "0" as position.
      position: index + 1
    }));
    set({ data: { ...data, phases: newPhases } });
  },
  addEmptyTag: () => {
    const { data } = get();
    const newTags = [...data.tags, EMPTY_TAG];
    set((old) => ({
      data: { ...old.data, tags: newTags }
    }));
  },
  updateTag: (index, newData) => {
    const { data } = get();
    const newTags = [...data.tags];
    newTags[index] = newData;
    set((old) => ({
      data: {
        ...old.data,
        tags: newTags
      }
    }));
  },
  removeTag: (tag) => {
    const index = get().data.tags.indexOf(tag);
    if (index < 0) return;
    set((old) => ({
      data: {
        ...old.data,
        tags: old.data.tags.filter((_, i) => i !== index)
      }
    }));
  }
}));

// src/lib/core/store/sales-compliant-search/index.ts
import { create as create5 } from "zustand";
var DEFAULT_STATE3 = {
  areFiltersOpen: false
};
var useSearchStore = create5((set) => ({
  ...DEFAULT_STATE3,
  toggleFilters: () => {
    set((state) => ({ areFiltersOpen: !state.areFiltersOpen }));
  },
  closeFilters: () => {
    set({ areFiltersOpen: false });
  },
  openFilters: () => {
    set({ areFiltersOpen: true });
  }
}));

// src/lib/core/store/sales-compliant-stats-by-grid/index.ts
import { create as create6 } from "zustand";
var DEFAULT_STATE4 = {
  isLoading: true,
  results: void 0,
  areFiltersOpen: false
};
var useSalesCompliantStatsByGridStore = create6(
  (set) => ({
    ...DEFAULT_STATE4,
    toggleFilters: () => {
      set((state) => ({ areFiltersOpen: !state.areFiltersOpen }));
    },
    closeFilters: () => {
      set({ areFiltersOpen: false });
    },
    openFilters: () => {
      set({ areFiltersOpen: true });
    },
    setStats: async (results) => {
      set({ results, isLoading: false });
    }
  })
);

// src/pages/exchange-details/components/back-link/index.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HREF_MAPPING = {
  SalesCompliant: "/sales-compliant/sales-activity",
  QualityMonitoring: "/quality-monitoring/exchanges"
};
var LOCAL_STORAGE_KEY = {
  SalesCompliant: "sc-filters",
  QualityMonitoring: "qm-filters"
};
function BackLink(props) {
  const { evaluation } = useEvaluationDetailsStore();
  const queryString = props.gridType && localStorage.getItem(LOCAL_STORAGE_KEY[props.gridType]) ? `?${localStorage.getItem(LOCAL_STORAGE_KEY[props.gridType])}` : "";
  if (!evaluation) return null;
  return /* @__PURE__ */ jsxs(
    AppLink,
    {
      to: HREF_MAPPING[evaluation.gridType] + queryString,
      className: "flex w-fit items-center gap-4 uppercase text-primary",
      ...props,
      children: [
        /* @__PURE__ */ jsx(Icon, { icon: faArrowLeft }),
        "Retour"
      ]
    }
  );
}

// src/pages/exchange-details/components/left-part/index.tsx
import { Heading1 as Heading14 } from "@oppy/omniv2-ui";

// src/lib/components/collapsible-criterias/components/group/index.tsx
import { cn, faChevronDown, faChevronUp, Icon as Icon4 } from "@oppy/omniv2-ui";
import { useState } from "react";

// src/lib/components/collapsible-criterias/components/sub-items/index.tsx
import { faEye, Icon as Icon3 } from "@oppy/omniv2-ui";

// src/lib/components/collapsible-criterias/components/thumbs-icon/index.tsx
import { faThumbsDown, faThumbsUp, faTimes as faTimes2, Icon as Icon2 } from "@oppy/omniv2-ui";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function ThumbsIcon({ type }) {
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    type === "Compliant" /* Compliant */ && /* @__PURE__ */ jsx2("div", { className: "flex size-7 items-center justify-center rounded-full bg-success p-2", children: /* @__PURE__ */ jsx2(Icon2, { icon: faThumbsUp, className: "text-white" }) }),
    type === "NonCompliant" /* NonCompliant */ && /* @__PURE__ */ jsx2("div", { className: "flex size-7 items-center justify-center rounded-full bg-[#9E9E9E] p-2", children: /* @__PURE__ */ jsx2(Icon2, { icon: faTimes2, className: "text-white" }) }),
    type === "PartiallyCompliant" /* PartiallyCompliant */ && /* @__PURE__ */ jsxs2("div", { className: "flex size-7 items-center justify-center gap-0.5 rounded-full bg-warning p-2", children: [
      /* @__PURE__ */ jsx2(Icon2, { icon: faThumbsUp, className: "size-3 text-white" }),
      /* @__PURE__ */ jsx2(Icon2, { icon: faThumbsDown, className: "size-3 text-white" })
    ] }),
    type === "NonApplicable" /* NonApplicable */ && /* @__PURE__ */ jsx2("div", { className: "flex size-7 items-center justify-center rounded-full bg-[#9E9E9E] p-2 opacity-25", children: /* @__PURE__ */ jsx2("span", { className: "text-xs", children: "N/A" }) })
  ] });
}

// src/lib/components/collapsible-criterias/components/sub-items/index.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
function SubItems({ subItems, onRowClick }) {
  return /* @__PURE__ */ jsx3("div", { className: "my-2 ml-6", children: subItems.map((item) => /* @__PURE__ */ jsxs3(
    "div",
    {
      className: "flex min-h-12 items-center gap-2 border-b pr-2",
      children: [
        /* @__PURE__ */ jsx3(ThumbsIcon, { type: item.compliantStatus }),
        /* @__PURE__ */ jsxs3("div", { className: "text-text-secondary opacity-55", children: [
          item.score,
          "/",
          item.maxScore
        ] }),
        /* @__PURE__ */ jsx3("div", { className: "flex-1", children: item.criterionName }),
        onRowClick && /* @__PURE__ */ jsx3("div", { className: "text-text-secondary opacity-55", children: /* @__PURE__ */ jsx3(
          Icon3,
          {
            role: "button",
            icon: faEye,
            className: "size-6",
            onClick: () => onRowClick(item)
          }
        ) })
      ]
    },
    item.criterionName
  )) });
}

// src/lib/components/collapsible-criterias/components/group/group.utils.ts
function getGlobalAppreciation(subItems) {
  if (subItems.every((item) => item.compliantStatus === "Compliant" /* Compliant */)) {
    return "Compliant" /* Compliant */;
  }
  if (subItems.some((item) => item.compliantStatus === "NonCompliant" /* NonCompliant */)) {
    return "NonCompliant" /* NonCompliant */;
  }
  if (subItems.some((item) => item.compliantStatus === "NonCompliant" /* NonCompliant */)) {
    return "PartiallyCompliant" /* PartiallyCompliant */;
  }
  if (subItems.some(
    (item) => item.compliantStatus === "PartiallyCompliant" /* PartiallyCompliant */
  )) {
    return "PartiallyCompliant" /* PartiallyCompliant */;
  }
  return "NonApplicable" /* NonApplicable */;
}
function getGlobalScore(subItems) {
  const numberOfPerfect = subItems.filter(
    (item) => item.score === item.maxScore
  ).length;
  return { score: numberOfPerfect, maxScore: subItems.length };
}

// src/lib/components/collapsible-criterias/components/group/index.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var DEFAULT_OPENED = true;
function Group({
  groupName,
  subItems = [],
  onRowClick
}) {
  const [open, setOpen] = useState(DEFAULT_OPENED);
  const globalAppreciation = getGlobalAppreciation(subItems);
  const { score, maxScore } = getGlobalScore(subItems);
  return /* @__PURE__ */ jsxs4("div", { "data-testid": "group", children: [
    /* @__PURE__ */ jsxs4(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: () => setOpen((old) => !old),
        className: cn(
          "flex items-center justify-between p-1.5 transition-all",
          { "bg-[#F1EDFA]": open }
        ),
        children: [
          /* @__PURE__ */ jsxs4("div", { className: "flex items-center gap-2 text-text-secondary text-opacity-55", children: [
            /* @__PURE__ */ jsx4(ThumbsIcon, { type: globalAppreciation }),
            /* @__PURE__ */ jsxs4("span", { children: [
              score,
              "/",
              maxScore
            ] }),
            /* @__PURE__ */ jsx4("span", { className: "font-bold", children: groupName })
          ] }),
          /* @__PURE__ */ jsx4(
            Icon4,
            {
              icon: open ? faChevronUp : faChevronDown,
              className: "text-text-secondary opacity-55"
            }
          )
        ]
      }
    ),
    open && /* @__PURE__ */ jsx4(SubItems, { subItems, onRowClick })
  ] });
}

// src/lib/components/collapsible-criterias/index.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function CollapsibleCriterias({ rows, onRowClick }) {
  return /* @__PURE__ */ jsx5("div", { "data-testid": "collapsible-criterias", children: rows.map((row) => /* @__PURE__ */ jsx5(Group, { ...row, onRowClick }, row.groupName)) });
}

// src/pages/exchange-details/components/left-part/index.tsx
import { useState as useState3 } from "react";

// src/lib/components/box/index.tsx
import { cn as cn2 } from "@oppy/omniv2-ui";
import { jsx as jsx6 } from "react/jsx-runtime";
function Box({ className, ...props }) {
  return /* @__PURE__ */ jsx6(
    "section",
    {
      "data-testid": "box",
      className: cn2("relative bg-white p-4 shadow rounded-lg", className),
      ...props
    }
  );
}

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-man-coffee.png
var d_man_coffee_default = "/assets/3d-man-coffee.2EE0107D.png";

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-man-crossed-arms.png
var d_man_crossed_arms_default = "/assets/3d-man-crossed-arms.D9BA604B.png";

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-man-smartphone.png
var d_man_smartphone_default = "/assets/3d-man-smartphone.2E668D7D.png";

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-man-zoom.png
var d_man_zoom_default = "/assets/3d-man-zoom.B187A2DE.png";

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-woman-laptop.png
var d_woman_laptop_default = "/assets/3d-woman-laptop.E11CC55D.png";

// @oppy/image-ns:/usr/src/app/packages/ia/src/assets/3d-woman-smartphone.png
var d_woman_smartphone_default = "/assets/3d-woman-smartphone.730C2891.png";

// src/lib/components/card-stats/card-stats.utils.ts
var STATS_IMAGE_MAPPING = {
  "3d-woman-smartphone": d_woman_smartphone_default,
  "3d-woman-laptop": d_woman_laptop_default,
  "3d-man-coffee": d_man_coffee_default,
  "3d-man-zoom": d_man_zoom_default,
  "3d-man-smartphone": d_man_smartphone_default,
  "3d-man-crossed-arms": d_man_crossed_arms_default
};
var STATS_TAG_MAPPING = {
  "this-week": "Cette semaine"
};

// src/lib/components/card-stats/index.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
function CardStats({
  value,
  percentEvolution,
  extra,
  tag,
  picto,
  title
}) {
  const image = picto && STATS_IMAGE_MAPPING[picto];
  const tagValue = STATS_TAG_MAPPING[tag];
  const percentSymbol = percentEvolution && percentEvolution < 0 ? "" : "+";
  return /* @__PURE__ */ jsxs5(Box, { "data-testid": "card-stats", className: "h-36", children: [
    /* @__PURE__ */ jsx7("div", { "data-testid": "card-stats-title", className: "mb-5 font-semibold", children: title }),
    /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx7("div", { "data-testid": "card-stats-value", className: "text-2xl", children: value }),
      percentEvolution !== void 0 && /* @__PURE__ */ jsxs5(
        "div",
        {
          "data-testid": "card-stats-percent",
          className: "text-xs text-success",
          children: [
            percentSymbol,
            percentEvolution,
            "%"
          ]
        }
      ),
      extra && /* @__PURE__ */ jsx7("div", { "data-testid": "card-stats-extra", className: "text-xs text-success", children: extra })
    ] }),
    /* @__PURE__ */ jsx7("div", { "data-testid": "card-stats-tag", className: "mt-2 text-xs", children: /* @__PURE__ */ jsx7(Tag, { children: tagValue }) }),
    image && /* @__PURE__ */ jsx7(
      "img",
      {
        "data-testid": "card-stats-image",
        src: image,
        alt: `picto ${picto}`,
        className: "absolute bottom-0 right-2 hidden sm:block"
      }
    )
  ] });
}

// src/lib/components/card-stats-skeleton/index.tsx
import { Skeleton } from "@oppy/omniv2-ui";
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
function CardStatsSkeleton() {
  return /* @__PURE__ */ jsxs6(Box, { "data-testid": "card-stats-skeleton", className: "h-36", children: [
    /* @__PURE__ */ jsx8(Skeleton, { className: "mb-10 w-14" }),
    /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx8(Skeleton, { className: "h-4 w-16" }),
      /* @__PURE__ */ jsx8(Skeleton, { className: "h-1 w-6" })
    ] }),
    /* @__PURE__ */ jsx8(Skeleton, { className: "mt-2 w-14" })
  ] });
}

// src/lib/components/chart-bar/index.tsx
import { Chart } from "@oppy/omniv2-ui";
import { jsx as jsx9 } from "react/jsx-runtime";
var COLORS = ["#76C73B", "#8A8D92", "#F4B73F"];
var DEFAULT_PROPS = {
  borderRadius: 100,
  barThickness: 10,
  borderSkipped: "middle"
};
function ChartBar({ data }) {
  return /* @__PURE__ */ jsx9(
    Chart,
    {
      "data-testid": "chart-bar",
      type: "bar",
      className: "m-auto size-full p-4",
      data: {
        ...data,
        datasets: data.datasets.map((row, index) => ({
          ...row,
          ...DEFAULT_PROPS,
          backgroundColor: COLORS[index]
        }))
      },
      options: {
        responsive: true,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        maintainAspectRatio: false,
        scales: {
          x: {
            display: false,
            stacked: true,
            barPercentage: 0.6,
            categoryPercentage: 0.6
          },
          y: { ticks: { display: false }, stacked: true }
        }
      }
    }
  );
}

// src/lib/components/chart-bar-percent/index.tsx
import { Chart as Chart2 } from "@oppy/omniv2-ui";
import { jsx as jsx10 } from "react/jsx-runtime";
var COLORS2 = ["#5CADA1"];
var SCALES_COLOR = "#3A35414D";
var DEFAULT_PROPS2 = {
  borderRadius: 100,
  barThickness: 15,
  borderSkipped: "middle"
};
function ChartBarPercent({ data }) {
  return /* @__PURE__ */ jsx10(
    Chart2,
    {
      "data-testid": "chart-bar-percent",
      type: "bar",
      className: "m-auto size-full p-4",
      data: {
        ...data,
        datasets: data.datasets.map((row, index) => ({
          ...row,
          ...DEFAULT_PROPS2,
          backgroundColor: COLORS2[index]
        }))
      },
      options: {
        responsive: true,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
            barPercentage: 0.6,
            categoryPercentage: 0.6,
            ticks: { color: SCALES_COLOR }
          },
          y: {
            min: 0,
            max: 100,
            ticks: {
              color: SCALES_COLOR,
              stepSize: 20,
              callback: (value) => value + "%"
            },
            stacked: true
          }
        }
      }
    }
  );
}

// src/lib/components/chart-doughnut/index.tsx
import { Chart as Chart3 } from "@oppy/omniv2-ui";
import { jsx as jsx11 } from "react/jsx-runtime";
var DEFAULT_PROPS3 = {
  backgroundColor: ["#76C73B", "#F4B73F", "#DE8283", "#9C7525"],
  borderColor: ["#76C73B", "#F4B73F", "#DE8283", "#9C7525"],
  borderWidth: 1
};
function ChartDoughnut({ data }) {
  return /* @__PURE__ */ jsx11(
    Chart3,
    {
      "data-testid": "chart-doughnut",
      type: "doughnut",
      className: "m-auto size-full p-4",
      data: {
        ...data,
        datasets: data.datasets.map((row) => ({ ...row, ...DEFAULT_PROPS3 }))
      },
      options: {
        scales: { y: { display: false } },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              usePointStyle: true,
              pointStyle: "circle",
              padding: 20,
              boxWidth: 10,
              boxHeight: 10,
              font: { size: 12 }
            }
          },
          tooltip: { enabled: true }
        },
        cutout: "70%"
      }
    }
  );
}

// src/lib/components/chart-line/index.tsx
import { Chart as Chart4 } from "@oppy/omniv2-ui";
import { jsx as jsx12 } from "react/jsx-runtime";
var COLORS3 = ["#65B8B3", "#D2A038"];
var HEX_OPACITY_CODE_10_PERCENT = "1A";
var SCALES_COLOR2 = "#3A35414D";
var DEFAULT_PROPS4 = {
  borderWidth: 4,
  cubicInterpolationMode: "monotone",
  tension: 0.4,
  pointRadius: 1,
  pointHoverRadius: 1
};
function ChartLine({ data }) {
  return /* @__PURE__ */ jsx12(
    Chart4,
    {
      "data-testid": "chart-line",
      type: "line",
      className: "m-auto size-full p-4",
      data: {
        ...data,
        datasets: data.datasets.map((row, index) => ({
          ...row,
          ...DEFAULT_PROPS4,
          borderColor: COLORS3[index],
          backgroundColor: COLORS3[index] + HEX_OPACITY_CODE_10_PERCENT,
          fill: true
        }))
      },
      options: {
        responsive: true,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        maintainAspectRatio: false,
        cutout: "70%",
        scales: {
          y: {
            ticks: { color: SCALES_COLOR2 },
            grid: { display: false }
          },
          x: { ticks: { color: SCALES_COLOR2 }, grid: { display: false } }
        }
      }
    }
  );
}

// src/lib/components/error/index.tsx
import { AppLink as AppLink2, Heading2 } from "@oppy/omniv2-ui";
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
function Error2({ title, children, link, onClick }) {
  return /* @__PURE__ */ jsxs7("p", { "data-testid": "error", className: "text-xs text-error", children: [
    title && /* @__PURE__ */ jsx13(Heading2, { children: title }),
    children,
    link && /* @__PURE__ */ jsx13("div", { className: "mt-4 text-base", children: /* @__PURE__ */ jsx13(AppLink2, { to: link.url, className: "underline", onClick, children: link.label }) })
  ] });
}

// src/lib/components/filter-button/index.tsx
import {
  faFilter,
  Icon as Icon5,
  ToggleButton
} from "@oppy/omniv2-ui";
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
function FilterButton({ disabled, selected, onClick }) {
  return /* @__PURE__ */ jsxs8(ToggleButton, { disabled, selected, onClick, children: [
    /* @__PURE__ */ jsx14(Icon5, { icon: faFilter, className: "mr-1" }),
    /* @__PURE__ */ jsx14("span", { className: "uppercase", children: "Filtres" })
  ] });
}

// src/lib/components/full-page-modal/index.tsx
import { faTimes as faTimes3, Icon as Icon6 } from "@oppy/omniv2-ui";
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";

// src/lib/components/grids-list/index.tsx
import {
  AppLink as AppLink3,
  cn as cn3,
  faPlusCircle,
  Heading1,
  Icon as Icon7,
  Table
} from "@oppy/omniv2-ui";
import { formatDate } from "@oppy/omniv2-utils";

// src/lib/hook/use-fetch-grids/index.ts
import { useEntity } from "@oppy/omniv2-entity";
import { useQuery } from "@tanstack/react-query";

// src/lib/services/grid.service.ts
import { omniApiClient as omniApiClient2 } from "@oppy/omniv2-core";
function findGridsOfType(entityId, gridType, options = {
  orderBy: "CreatedAt",
  sortDirection: "Descending"
}) {
  const searchParams = new URLSearchParams();
  searchParams.set("gridType", gridType);
  searchParams.set("orderBy", options.orderBy);
  searchParams.set("sortDirection", options.sortDirection);
  if (options.isActive !== void 0) {
    searchParams.set("isActive", options.isActive.toString());
  }
  return omniApiClient2.get(
    `${getBaseUrl(entityId)}evaluationGrids?${searchParams.toString()}`
  );
}
function createOrUpdateGrid({
  entityId,
  data
}) {
  const isEditMode = !!data.id;
  return omniApiClient2({
    url: `${getBaseUrl(entityId)}evaluationGrids${isEditMode ? `/${data.id}` : ""}`,
    method: isEditMode ? "put" : "post",
    data,
    headers: {
      "Content-type": "application/json"
    }
  });
}
function toggleGrid({
  entityId,
  toggleEvaluationGridRequests
}) {
  return omniApiClient2.put(`${getBaseUrl(entityId)}evaluationGrids/toggle`, {
    toggleEvaluationGridRequests
  });
}
function findGridById(entityId, gridId) {
  return omniApiClient2.get(`${getBaseUrl(entityId)}evaluationGrids/${gridId}`);
}

// src/lib/hook/use-fetch-grids/index.ts
var FETCH_GRIDS_QUERY_KEY = "find-grids";
function useFetchGrids(gridType, options = {
  orderBy: "CreatedAt",
  sortDirection: "Descending",
  isActive: void 0
}) {
  const { entityId } = useEntity();
  return useQuery({
    queryKey: [FETCH_GRIDS_QUERY_KEY, gridType, options],
    queryFn: () => findGridsOfType(entityId, gridType, options),
    staleTime: DEFAULT_STALE_TIME
  });
}

// src/lib/components/grids-list/index.tsx
import { useSearchParams } from "react-router-dom";

// src/lib/components/grids-list/components/grid-popup-menu/index.tsx
import { useEntity as useEntity2 } from "@oppy/omniv2-entity";
import { PopupMenu, updateTemplate } from "@oppy/omniv2-ui";
import { jsx as jsx16 } from "react/jsx-runtime";
function GridPopupMenu({ id, gridType }) {
  const { entityId } = useEntity2();
  const to = gridType === "SalesCompliant" ? `/${entityId}/sales-compliant/new-grid?updateGridId=${id}` : `/${entityId}/quality-monitoring/new-grid?updateGridId=${id}`;
  return /* @__PURE__ */ jsx16(
    PopupMenu,
    {
      items: [
        updateTemplate({
          to
        })
      ]
    }
  );
}

// src/lib/components/grids-list/components/toggle-grid-status/index.tsx
import { useEntity as useEntity3 } from "@oppy/omniv2-entity";
import { Loading, useToastContext } from "@oppy/omniv2-ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Fragment as Fragment2, jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
function ToggleGridStatus({ id, name, isActive }) {
  const queryClient = useQueryClient();
  const { entityId } = useEntity3();
  const { showMessage } = useToastContext();
  const { mutate, isPending } = useMutation({
    mutationFn: toggleGrid,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["find-grids"] });
      showMessage({
        severity: "success",
        summary: "Succ\xE8s !",
        detail: /* @__PURE__ */ jsxs10(Fragment2, { children: [
          /* @__PURE__ */ jsx17("b", { children: name }),
          " a bien \xE9t\xE9 ",
          isActive ? "d\xE9sactiv\xE9e" : "activ\xE9e"
        ] })
      });
    }
  });
  return /* @__PURE__ */ jsxs10("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx17(
      "input",
      {
        type: "checkbox",
        checked: isActive,
        onChange: (event) => {
          const isActive2 = event.currentTarget.checked;
          mutate({
            entityId,
            toggleEvaluationGridRequests: [{ id, isActive: isActive2 }]
          });
        },
        disabled: isPending
      }
    ),
    isPending && /* @__PURE__ */ jsx17(Loading, {}),
    !isPending && /* @__PURE__ */ jsx17(Fragment2, { children: isActive ? "Activ\xE9" : "Inactive" })
  ] });
}

// src/lib/components/grids-list/index.tsx
import { Fragment as Fragment3, jsx as jsx18, jsxs as jsxs11 } from "react/jsx-runtime";
function GridsList({ gridType }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = {
    orderBy: searchParams.get("orderBy") || "CreatedAt",
    sortDirection: searchParams.get(
      "sortDirection"
    ) || "Descending"
  };
  const { data, isPending, isError, failureReason } = useFetchGrids(
    gridType,
    filters
  );
  return /* @__PURE__ */ jsxs11(Fragment3, { children: [
    /* @__PURE__ */ jsxs11("div", { className: "mb-6 flex items-center justify-between", children: [
      /* @__PURE__ */ jsx18(Heading1, { className: "text-4xl text-text-secondary/70", children: "Gestion des grilles" }),
      /* @__PURE__ */ jsxs11(
        AppLink3,
        {
          to: gridType === "SalesCompliant" ? "/sales-compliant/new-grid" : "/quality-monitoring/new-grid",
          className: cn3(
            "py-2 px-6 uppercase rounded-lg text-sm transition-all text-center bg-white text-primary hover:text-primary/80 border border-purple/50 hover:border-purple/75",
            { "pointer-events-none opacity-50": isPending }
          ),
          "aria-disabled": isPending,
          children: [
            /* @__PURE__ */ jsx18(Icon7, { icon: faPlusCircle }),
            " Nouvelle grille"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxs11(Section, { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ jsx18(Heading1, { className: "text-center", children: "Grilles d'\xE9valuations" }),
      isError && failureReason && /* @__PURE__ */ jsx18(
        Error2,
        {
          title: "Impossible de r\xE9cup\xE9rer les grilles",
          link: { url: "/", label: "Retourner \xE0 l'accueil" },
          children: failureReason?.message
        }
      ),
      !isError && /* @__PURE__ */ jsx18(
        Table,
        {
          value: data || [],
          columns: [
            {
              field: "CreatedAt",
              header: "Date de cr\xE9ation",
              body: ({ createdAt }) => formatDate(createdAt),
              sortable: true,
              bodyClassName: "w-[160px]"
            },
            {
              field: "name",
              header: "Nom"
            },
            {
              field: "IsActive",
              header: "Active",
              body: (grid) => /* @__PURE__ */ jsx18(ToggleGridStatus, { ...grid }, grid.id),
              sortable: true,
              bodyClassName: "w-[100px]"
            },
            {
              field: "UpdatedAt",
              header: "Modification",
              body: ({ updatedAt }) => formatDate(updatedAt),
              sortable: true,
              bodyClassName: "w-[160px]"
            },
            {
              field: "menu",
              header: "",
              body: (props) => /* @__PURE__ */ jsx18(GridPopupMenu, { ...props, gridType }),
              bodyClassName: "w-[50px]"
            }
          ],
          loading: isPending,
          sortField: filters?.orderBy,
          sortOrder: filters?.sortDirection === "Ascending" ? 1 : -1,
          onSort: (event) => {
            searchParams.set("orderBy", event.sortField);
            searchParams.set(
              "sortDirection",
              event.sortOrder === 1 ? "Ascending" : "Descending"
            );
            setSearchParams(searchParams, { replace: true });
          },
          totalRecords: data?.length,
          paginator: false
        }
      )
    ] })
  ] });
}

// src/lib/components/play-button/index.tsx
import { faPause, faPlay, Icon as Icon8 } from "@oppy/omniv2-ui";
import { jsx as jsx19 } from "react/jsx-runtime";
function PlayButton({ isPlaying, ...props }) {
  return /* @__PURE__ */ jsx19(
    Icon8,
    {
      role: "button",
      tabIndex: 0,
      icon: isPlaying ? faPause : faPlay,
      className: "size-2 rounded-full bg-primary p-1.5 text-white",
      ...props
    }
  );
}

// src/lib/components/play-sound-button/index.tsx
import { useEntity as useEntity4 } from "@oppy/omniv2-entity";
import { faWarning, Icon as Icon9, Loading as Loading2 } from "@oppy/omniv2-ui";
import { useQuery as useQuery2 } from "@tanstack/react-query";

// src/pages/exchange-details/components/player/player.utils.ts
function getDurationOfAudioFile(audioFile) {
  return new Promise((resolve) => {
    if (!audioFile) {
      return resolve({
        durationAsString: "00:00",
        durationAsSeconds: 0
      });
    }
    const audioElement = new Audio(audioFile);
    audioElement.onloadedmetadata = () => {
      const totalSeconds = Math.floor(audioElement.duration);
      const minutes = String(Math.floor(totalSeconds % 3600 / 60)).padStart(
        2,
        "0"
      );
      const seconds = (totalSeconds % 60).toString().padStart(2, "0");
      resolve({
        durationAsString: `${minutes}:${seconds}`,
        durationAsSeconds: totalSeconds
      });
    };
    audioElement.onerror = () => {
      resolve({
        durationAsString: "00:00",
        durationAsSeconds: 0
      });
    };
  });
}

// src/lib/components/play-sound-button/index.tsx
import { useEffect, useRef, useState as useState2 } from "react";
import { Fragment as Fragment4, jsx as jsx20, jsxs as jsxs12 } from "react/jsx-runtime";
function PlaySoundButton({ evaluatedCallId }) {
  const { entityId } = useEntity4();
  const audioRef = useRef(null);
  const [isQueryEnabled, setIsQueryEnabled] = useState2(false);
  const [isPlaying, setIsPlaying] = useState2(false);
  const { data, isLoading, isError } = useQuery2({
    queryKey: ["audio-for-evaluation", evaluatedCallId],
    queryFn: () => findAudioByEvaluationId(evaluatedCallId, entityId).then((blob) => URL.createObjectURL(blob)).then(async (audioFile) => ({
      audioFile,
      ...await getDurationOfAudioFile(audioFile)
    })),
    enabled: isQueryEnabled,
    staleTime: DEFAULT_STALE_TIME,
    retry: false
  });
  useEffect(() => {
    if (!data || !audioRef.current || !isQueryEnabled) return;
    audioRef.current.play();
    setIsPlaying(true);
    return () => {
      setIsQueryEnabled(false);
    };
  }, [data, isQueryEnabled]);
  return /* @__PURE__ */ jsxs12(Fragment4, { children: [
    isLoading && /* @__PURE__ */ jsx20(Loading2, {}),
    !isLoading && !isError && /* @__PURE__ */ jsx20(
      PlayButton,
      {
        isPlaying,
        onClick: () => {
          if (data && audioRef.current) {
            if (isPlaying) {
              audioRef.current.pause();
              setIsPlaying(false);
            } else {
              audioRef.current.play();
              setIsPlaying(true);
            }
            return;
          }
          setIsQueryEnabled(true);
        }
      }
    ),
    isError && /* @__PURE__ */ jsx20(
      Icon9,
      {
        icon: faWarning,
        className: "size-4 text-warning",
        title: "Impossible de r\xE9cup\xE9rer le fichier"
      }
    ),
    data?.audioFile && /* @__PURE__ */ jsx20("audio", { ref: audioRef, src: data.audioFile, className: "hidden" })
  ] });
}

// src/lib/components/section/index.tsx
import { cn as cn4 } from "@oppy/omniv2-ui";
import { jsx as jsx21 } from "react/jsx-runtime";
function Section({ className, ...props }) {
  return /* @__PURE__ */ jsx21(
    "section",
    {
      "data-testid": "section",
      className: cn4(
        "relative bg-white p-4 shadow rounded-lg overflow-auto",
        className
      ),
      ...props
    }
  );
}

// src/lib/components/tag/index.tsx
import { cn as cn5 } from "@oppy/omniv2-ui";
import { jsx as jsx22 } from "react/jsx-runtime";
function Tag({ variant = "primary", ...props }) {
  return /* @__PURE__ */ jsx22(
    "div",
    {
      "data-testid": "tag",
      "data-variant": variant,
      className: cn5(
        `w-fit rounded-full py-1 px-2 text-sm text-${variant} bg-${variant}-background`
      ),
      ...props
    }
  );
}

// src/lib/components/transcript/components/bubble/index.tsx
import { cn as cn6 } from "@oppy/omniv2-ui";
import { Fragment as Fragment5, jsx as jsx23, jsxs as jsxs13 } from "react/jsx-runtime";
function Bubble({
  text,
  speaker,
  startedOffsetInSeconds,
  showTime,
  utteranceIndex,
  isHighlighted
}) {
  const minutes = Math.floor(startedOffsetInSeconds / 60).toString().padStart(2, "0");
  const seconds = Math.floor(startedOffsetInSeconds % 60).toString().padStart(2, "0");
  return /* @__PURE__ */ jsxs13(Fragment5, { children: [
    /* @__PURE__ */ jsx23(
      "div",
      {
        "data-testid": "bubble",
        "data-utterance-index": `${utteranceIndex}`,
        className: cn6("flex mb-2", { "justify-end": speaker === 1 }),
        children: /* @__PURE__ */ jsx23(
          "div",
          {
            className: cn6(
              "w-fit text-sm p-2 shadow rounded-lg max-w-[85%] border border-transparent transition-all",
              {
                "bg-white rounded-tl-none": speaker === 0,
                "bg-primary text-white rounded-tr-none": speaker === 1,
                "border-warning": isHighlighted
              }
            ),
            children: text
          }
        )
      }
    ),
    showTime && /* @__PURE__ */ jsxs13(
      "div",
      {
        className: cn6("flex text-xs text-black/50 mb-2", {
          "justify-end": speaker === 1
        }),
        children: [
          minutes,
          ":",
          seconds
        ]
      }
    )
  ] });
}

// src/lib/components/transcript/index.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
function Transcript({ data, currentUtteranceIndex }) {
  return /* @__PURE__ */ jsx24("div", { "data-testid": "transcript", className: "mt-4 px-4", children: data.map((row, index) => {
    const showTime = index >= data.length - 1 ? true : data[index + 1].speaker !== row.speaker;
    return /* @__PURE__ */ jsx24(
      Bubble,
      {
        utteranceIndex: index,
        ...row,
        showTime,
        isHighlighted: currentUtteranceIndex === index
      },
      row.startedOffsetInSeconds
    );
  }) });
}

// src/pages/exchange-details/components/header/index.tsx
import {
  Badge,
  CustomIcon,
  faCheck as faCheck2,
  faThumbsDown as faThumbsDown2,
  Heading1 as Heading12,
  Icon as Icon10
} from "@oppy/omniv2-ui";

// src/lib/utils/index.ts
function formatToKEuros(value, withSymbol = true) {
  if (value < 1e3 && value > -1e3) return value.toFixed(1);
  return (value / 1e3).toFixed(1) + `k${withSymbol ? "\u20AC" : ""}`;
}
function formatDate2(date, withHours = false) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${year}-${month}-${day}${withHours ? `T${hours}:${minutes}` : ""}`;
}
function findUtteranceByTime(timeInSeconds, utterances) {
  const rounded = Math.round(timeInSeconds);
  const utterance = utterances.find(
    (item) => rounded >= Math.round(item.startedOffsetInSeconds) && rounded < Math.round(item.endedOffsetInSeconds)
  );
  if (!utterance) return;
  const index = utterances.indexOf(utterance);
  return { index, utterance };
}
function getRateInPercentFromEvaluation(evaluation) {
  if (!evaluation.score || !evaluation.maxScore) return 0;
  const { score, maxScore } = evaluation;
  const percentage = 100 * score / maxScore;
  return isNaN(percentage) ? 0 : percentage;
}

// src/pages/exchange-details/components/header/index.tsx
import { jsx as jsx25, jsxs as jsxs14 } from "react/jsx-runtime";
function Header() {
  const { evaluation } = useEvaluationDetailsStore();
  if (!evaluation) return null;
  const { compliantStatus } = evaluation;
  const percent = getRateInPercentFromEvaluation(evaluation);
  const isCompliant = compliantStatus === "Compliant" /* Compliant */;
  let variant;
  let icon;
  if (percent === 0) {
    variant = "disabled";
    icon = "TIMES_HEXAGON";
  } else if (percent < 80) {
    variant = "error";
    icon = "THUMBS_DONW";
  } else if (percent < 100) {
    variant = "warning";
    icon = "THUMBS_UP_DONW";
  } else {
    variant = "success";
    icon = "THUMBS_UP";
  }
  return /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ jsx25(Heading12, { children: "Conformit\xE9 process" }),
    /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs14(Badge, { variant: isCompliant ? "success" : "error", children: [
        /* @__PURE__ */ jsx25(Icon10, { icon: isCompliant ? faCheck2 : faThumbsDown2 }),
        "\xA0 ",
        isCompliant ? "Oui" : "Non"
      ] }),
      /* @__PURE__ */ jsx25(Badge, { variant, children: /* @__PURE__ */ jsxs14("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx25(CustomIcon, { name: icon, className: "inline-block size-4" }),
        " ",
        /* @__PURE__ */ jsxs14("span", { children: [
          percent.toFixed(2),
          "%"
        ] })
      ] }) })
    ] })
  ] });
}

// src/pages/exchange-details/components/overlay/index.tsx
import { Button, faChevronRight, Heading1 as Heading13, Icon as Icon12 } from "@oppy/omniv2-ui";

// src/pages/exchange-details/components/key-points/index.tsx
import { CustomIcon as CustomIcon2, faVolumeHigh, Icon as Icon11 } from "@oppy/omniv2-ui";
import { jsx as jsx26, jsxs as jsxs15 } from "react/jsx-runtime";
function KeyPoints({ keyPoints }) {
  const { evaluation } = useEvaluationDetailsStore();
  const { setIsPlaying, setCurrentUtteranceIndex } = useEvaluationAudioStore();
  if (!evaluation || !keyPoints?.length) return null;
  return /* @__PURE__ */ jsx26(
    "div",
    {
      "data-testid": "key-points",
      className: "mt-6 flex flex-col items-center gap-4",
      children: keyPoints?.map((keyPoint, index) => /* @__PURE__ */ jsxs15(
        "div",
        {
          "data-testid": `key-point-${index}`,
          role: "button",
          className: "flex flex-row gap-4 rounded-xl border border-blue/50 bg-blue/10 p-4 text-primary transition-all hover:bg-blue/15",
          onClick: () => {
            const output = findUtteranceByTime(
              keyPoint.startedOffsetInSeconds,
              evaluation.utterances
            );
            if (output) {
              setIsPlaying(true, keyPoint.startedOffsetInSeconds);
              setCurrentUtteranceIndex(output.index);
            }
          },
          children: [
            /* @__PURE__ */ jsx26("div", { className: "size-6", children: /* @__PURE__ */ jsx26(CustomIcon2, { name: "AI_BRAIN" }) }),
            keyPoint.reason,
            /* @__PURE__ */ jsx26(Icon11, { icon: faVolumeHigh })
          ]
        },
        keyPoint.startedOffsetInSeconds
      ))
    }
  );
}

// src/pages/exchange-details/components/overlay/index.tsx
import { jsx as jsx27, jsxs as jsxs16 } from "react/jsx-runtime";
function Overlay({ gradeCriteria, onHide }) {
  if (!gradeCriteria) return null;
  return /* @__PURE__ */ jsxs16(
    "div",
    {
      "data-testid": "overlay",
      className: "absolute right-0 top-0 z-10 size-full",
      children: [
        /* @__PURE__ */ jsx27(
          "div",
          {
            role: "button",
            "data-testid": "backdrop",
            className: "absolute size-full bg-black/50",
            title: "Fermer",
            onClick: onHide
          }
        ),
        /* @__PURE__ */ jsx27(
          "div",
          {
            "data-testid": "content",
            className: "absolute right-0 h-full w-3/4 overflow-auto rounded-l-lg bg-white p-4",
            children: /* @__PURE__ */ jsxs16("div", { className: "flex h-full flex-col items-start justify-between", children: [
              /* @__PURE__ */ jsxs16("div", { className: "flex-1", children: [
                /* @__PURE__ */ jsxs16("div", { className: "mb-4 flex items-center justify-between", children: [
                  /* @__PURE__ */ jsx27(Heading13, { children: gradeCriteria.criterionName }),
                  /* @__PURE__ */ jsx27(
                    Icon12,
                    {
                      icon: faChevronRight,
                      className: "size-3",
                      role: "button",
                      onClick: onHide
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx27("p", { children: gradeCriteria.comment }),
                /* @__PURE__ */ jsxs16("p", { className: "text-text-secondary/70", children: [
                  "Score : ",
                  gradeCriteria.score,
                  "/",
                  gradeCriteria.maxScore
                ] }),
                /* @__PURE__ */ jsx27(KeyPoints, { keyPoints: gradeCriteria.keyPoints })
              ] }),
              /* @__PURE__ */ jsx27("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ jsx27(Button, { variant: "link-secondary", onClick: onHide, children: "Fermer" }) })
            ] })
          }
        )
      ]
    }
  );
}

// src/pages/exchange-details/components/left-part/index.tsx
import { Fragment as Fragment6, jsx as jsx28, jsxs as jsxs17 } from "react/jsx-runtime";
function LeftPart() {
  const { evaluation } = useEvaluationDetailsStore();
  const [selectedGradeCriteria, setSelectedGradeCriteria] = useState3();
  if (!evaluation) return null;
  const { gradeCriteria } = evaluation;
  const groups = [...new Set(gradeCriteria.map((item) => item.category))];
  const rows = groups.map((groupName) => {
    const subItems = gradeCriteria.filter(
      (criteria) => criteria.category === groupName
    );
    const score = subItems.reduce((prev, curr) => prev + curr.score, 0);
    const maxScore = subItems.length;
    return {
      groupName,
      score,
      maxScore,
      subItems
    };
  });
  return /* @__PURE__ */ jsxs17(Section, { "data-testid": "left-part", className: "relative", children: [
    /* @__PURE__ */ jsx28(
      Overlay,
      {
        gradeCriteria: selectedGradeCriteria,
        onHide: () => setSelectedGradeCriteria(void 0)
      }
    ),
    /* @__PURE__ */ jsx28("div", { className: "mb-6", children: /* @__PURE__ */ jsx28(Header, {}) }),
    /* @__PURE__ */ jsxs17("div", { className: "h-[calc(100vh-220px)] overflow-auto", children: [
      /* @__PURE__ */ jsx28(
        CollapsibleCriterias,
        {
          rows,
          onRowClick: setSelectedGradeCriteria
        }
      ),
      evaluation.summary && /* @__PURE__ */ jsxs17(Fragment6, { children: [
        /* @__PURE__ */ jsx28("hr", { className: "my-4" }),
        /* @__PURE__ */ jsx28(Heading14, { children: "R\xE9sum\xE9" }),
        /* @__PURE__ */ jsx28("span", { children: evaluation.summary })
      ] })
    ] })
  ] });
}

// src/pages/exchange-details/components/right-part/index.tsx
import { useEffect as useEffect3, useRef as useRef4 } from "react";

// src/pages/exchange-details/components/player/index.tsx
import { Loading as Loading3 } from "@oppy/omniv2-ui";
import { useQuery as useQuery3 } from "@tanstack/react-query";
import { useCallback, useEffect as useEffect2, useRef as useRef3 } from "react";
import { useParams } from "react-router-dom";

// src/pages/exchange-details/components/strong-moments/index.tsx
import { cn as cn7 } from "@oppy/omniv2-ui";
import { useLayoutEffect, useRef as useRef2, useState as useState4 } from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var COLORS4 = { BACKGROUND: "#BDBDBD", STRONG_MOMENT: "#9E9E9E" };
function StrongMoments({ fileDurationInSeconds }) {
  const { evaluation } = useEvaluationDetailsStore();
  const { setSelectedStrongMoment, setCurrentUtteranceIndex, setIsPlaying } = useEvaluationAudioStore();
  const ref = useRef2(null);
  const [maxWidth, setMaxWidth] = useState4(0);
  useLayoutEffect(() => {
    const handleResize = () => {
      setMaxWidth(ref.current?.offsetWidth || 0);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!evaluation) return null;
  const strongMoments = evaluation.gradeCriteria.map((item) => item.keyPoints).flat().filter((item) => !!item?.startedOffsetInSeconds);
  const barWidth = maxWidth / fileDurationInSeconds;
  return /* @__PURE__ */ jsx29(
    "div",
    {
      ref,
      className: "flex h-11 w-full items-center overflow-hidden rounded-full bg-slate-50",
      children: [...Array(fileDurationInSeconds).keys()].map((index) => {
        const strongMoment = strongMoments.find(
          (item) => Math.floor(item.startedOffsetInSeconds) === index
        );
        const isStrongMoment = !!strongMoment;
        return /* @__PURE__ */ jsx29(
          "div",
          {
            className: cn7("h-full bg-[#BDBDBD]", {
              [`bg-[${COLORS4.STRONG_MOMENT}] transition-all hover:bg-opacity-90 cursor-pointer`]: isStrongMoment
            }),
            style: { width: barWidth },
            role: isStrongMoment ? "button" : void 0,
            tabIndex: isStrongMoment ? 0 : void 0,
            onClick: isStrongMoment ? () => {
              const { startedOffsetInSeconds } = strongMoment;
              const output = findUtteranceByTime(
                startedOffsetInSeconds,
                evaluation.utterances
              );
              if (output) {
                setSelectedStrongMoment(strongMoment);
                setCurrentUtteranceIndex(output.index);
                setIsPlaying(true, startedOffsetInSeconds);
              }
            } : void 0
          },
          index
        );
      })
    }
  );
}

// src/pages/exchange-details/components/player/index.tsx
import { Fragment as Fragment7, jsx as jsx30, jsxs as jsxs18 } from "react/jsx-runtime";
function Player() {
  const audioRef = useRef3(null);
  const { id = "", entityId = "" } = useParams();
  const { evaluation } = useEvaluationDetailsStore();
  const {
    isPlaying,
    startPlayingTime,
    setIsPlaying,
    setCurrentUtteranceIndex
  } = useEvaluationAudioStore();
  const { data, isLoading, isError } = useQuery3({
    queryKey: ["audio-for-evaluation", id],
    queryFn: () => findAudioByEvaluationId(id, entityId).then((blob) => URL.createObjectURL(blob)).then(async (audioFile) => ({
      audioFile,
      ...await getDurationOfAudioFile(audioFile)
    })),
    enabled: !!evaluation && !!id,
    staleTime: DEFAULT_STALE_TIME
  });
  const handleTimeUpdate = useCallback(() => {
    if (!evaluation) return;
    const currentTime = audioRef.current?.currentTime;
    if (!currentTime) return;
    const utterance = evaluation.utterances.find(
      (item) => currentTime >= item.startedOffsetInSeconds && currentTime < item.endedOffsetInSeconds
    );
    if (!utterance) return;
    const index = evaluation.utterances.indexOf(utterance);
    setCurrentUtteranceIndex(index);
  }, [evaluation, setCurrentUtteranceIndex]);
  useEffect2(() => {
    if (!audioRef.current) return;
    const addTimeUpdateEvent = () => {
      audioRef.current?.addEventListener("timeupdate", handleTimeUpdate);
    };
    const stopTimeUpdateEvent = () => {
      audioRef.current?.removeEventListener("timeupdate", handleTimeUpdate);
    };
    if (isPlaying) {
      audioRef.current.currentTime = startPlayingTime;
      audioRef.current.play();
      addTimeUpdateEvent();
    } else {
      audioRef.current.pause();
      stopTimeUpdateEvent();
    }
  }, [isPlaying, startPlayingTime, handleTimeUpdate]);
  if (!evaluation) return null;
  return /* @__PURE__ */ jsxs18(Section, { className: "flex items-center justify-between gap-4 p-1.5 text-primary", children: [
    isLoading && /* @__PURE__ */ jsx30("div", { className: "flex h-11 w-full items-center justify-center", children: /* @__PURE__ */ jsx30(Loading3, {}) }),
    !isLoading && isError && /* @__PURE__ */ jsx30("div", { className: "flex h-12 items-center", children: /* @__PURE__ */ jsx30(Error2, { children: "Impossible de charger le fichier audio" }) }),
    !isLoading && !!data && /* @__PURE__ */ jsxs18(Fragment7, { children: [
      /* @__PURE__ */ jsxs18("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx30(
          PlayButton,
          {
            isPlaying,
            onClick: () => {
              setIsPlaying(!isPlaying, audioRef.current?.currentTime);
            }
          }
        ),
        /* @__PURE__ */ jsx30("span", { className: "text-sm", children: data.durationAsString })
      ] }),
      data.audioFile && /* @__PURE__ */ jsx30("audio", { ref: audioRef, src: data.audioFile, className: "hidden" }),
      /* @__PURE__ */ jsx30(StrongMoments, { fileDurationInSeconds: data.durationAsSeconds })
    ] })
  ] });
}

// src/pages/exchange-details/components/right-part/index.tsx
import { jsx as jsx31, jsxs as jsxs19 } from "react/jsx-runtime";
var BUBBLE_OFFSET = 400;
function RightPart() {
  const { evaluation } = useEvaluationDetailsStore();
  const { currentUtteranceIndex } = useEvaluationAudioStore();
  const ref = useRef4(null);
  useEffect3(() => {
    const element = document.querySelector(
      `[data-testid="bubble"][data-utterance-index="${currentUtteranceIndex}"]`
    );
    if (!element) return;
    ref.current?.scrollTo({
      top: element.offsetTop - BUBBLE_OFFSET,
      behavior: "smooth"
    });
  }, [currentUtteranceIndex]);
  if (!evaluation) return null;
  return /* @__PURE__ */ jsxs19("div", { className: "bg-transcript px-1", children: [
    /* @__PURE__ */ jsx31(Player, {}),
    /* @__PURE__ */ jsx31("div", { ref, className: "h-[calc(100vh-190px)] overflow-auto", children: /* @__PURE__ */ jsx31(
      Transcript,
      {
        data: evaluation.utterances,
        currentUtteranceIndex
      }
    ) })
  ] });
}

// src/pages/exchange-details/index.tsx
import { Fragment as Fragment8, jsx as jsx32, jsxs as jsxs20 } from "react/jsx-runtime";
function ExchangeDetails() {
  const navigate = useNavigate();
  const { entityId = "", id = "" } = useParams2();
  const { reset, setEvaluation } = useEvaluationDetailsStore();
  const { data: evaluation, isLoading } = useQuery4({
    queryKey: ["evaluation-by-id", id],
    queryFn: () => findEvaluationById(id, entityId),
    enabled: !!id,
    staleTime: DEFAULT_STALE_TIME
  });
  useEffect4(() => {
    if (isLoading) return;
    if (!evaluation) {
      navigate(`/${entityId}`);
      return;
    }
    setEvaluation(evaluation);
  }, [entityId, evaluation, isLoading, navigate, setEvaluation]);
  if (!id) return null;
  return /* @__PURE__ */ jsxs20(Fragment8, { children: [
    /* @__PURE__ */ jsx32("div", { className: "mb-6", children: /* @__PURE__ */ jsx32(BackLink, { onClick: reset, gridType: evaluation?.gridType }) }),
    isLoading && /* @__PURE__ */ jsx32(Loading4, {}),
    !isLoading && !!evaluation && /* @__PURE__ */ jsxs20("div", { className: "grid grid-cols-12", children: [
      /* @__PURE__ */ jsx32("div", { className: "col-span-8", children: /* @__PURE__ */ jsx32(LeftPart, {}) }),
      /* @__PURE__ */ jsx32("div", { className: "col-span-4", children: /* @__PURE__ */ jsx32(RightPart, {}) })
    ] })
  ] });
}

// src/pages/grids-management/index.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
function GridsManagement({ gridType }) {
  return /* @__PURE__ */ jsx33(GridsList, { gridType });
}

// src/pages/new-grid/index.tsx
import { useEntity as useEntity5 } from "@oppy/omniv2-entity";
import { Loading as Loading6, Stepper } from "@oppy/omniv2-ui";
import { useQuery as useQuery5 } from "@tanstack/react-query";
import { useEffect as useEffect6 } from "react";
import { useSearchParams as useSearchParams2 } from "react-router-dom";

// src/pages/new-grid/components/header-stepper-template/index.tsx
import {
  Heading1 as Heading15,
  StepItem
} from "@oppy/omniv2-ui";
import { jsx as jsx34, jsxs as jsxs21 } from "react/jsx-runtime";
import { createElement } from "react";
function HeaderStepperTemplate({
  activeStep,
  items,
  linear,
  title
}) {
  return /* @__PURE__ */ jsxs21("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx34("div", { className: "m-auto flex w-2/3 items-center gap-4", children: items.map((item, index) => /* @__PURE__ */ createElement(
      StepItem,
      {
        ...item,
        isActive: activeStep >= index,
        key: item.title,
        index,
        linear,
        showSeparator: index < items.length - 1
      }
    )) }),
    /* @__PURE__ */ jsx34(Heading15, { className: "text-4xl text-text-secondary/70", children: title })
  ] });
}

// src/pages/new-grid/new-grid.config.ts
import { useCallback as useCallback2, useEffect as useEffect5 } from "react";
import { useNavigate as useNavigate4, useParams as useParams5 } from "react-router-dom";

// src/pages/new-grid/components/step-1/index.tsx
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Heading1 as Heading16,
  Heading2 as Heading22,
  Input,
  Switch,
  TextArea,
  useStepperContext,
  useStepperHandle
} from "@oppy/omniv2-ui";

// src/lib/components/double-slider/index.tsx
import { cn as cn8, Slider } from "@oppy/omniv2-ui";
import { jsx as jsx35, jsxs as jsxs22 } from "react/jsx-runtime";
function DoubleSlider({ value, ...props }) {
  return /* @__PURE__ */ jsxs22("div", { "data-testid": "double-slider", className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsx35("div", { className: "text-center", children: /* @__PURE__ */ jsx35("span", { children: typeof value === "number" ? value : value?.join(" - ") }) }),
    /* @__PURE__ */ jsx35(
      Slider,
      {
        ...props,
        className: "w-56",
        value,
        range: true,
        pt: {
          root: ({ props: props2 }) => ({
            className: cn8(
              "relative",
              "bg-gray-100 border-0 rounded-6",
              {
                "h-1 w-full": props2.orientation === "horizontal",
                "w-1 h-56": props2.orientation === "vertical"
              },
              {
                "opacity-60 select-none pointer-events-none cursor-default": props2.disabled
              }
            )
          }),
          range: ({ props: props2 }) => ({
            className: cn8("bg-primary", "block absolute", {
              "top-0 left-0 h-full": props2.orientation === "horizontal",
              "bottom-0 left-0 w-full": props2.orientation === "vertical"
            })
          }),
          handle: ({ props: props2 }) => ({
            className: cn8(
              "size-5 bg-warning rounded-full transition duration-200",
              "cursor-grab touch-action-none block",
              "focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]",
              "hover:bg-warning",
              {
                "top-[50%] mt-[-0.5715rem] ml-[-0.5715rem]": props2.orientation === "horizontal",
                "left-[50%] mb-[-0.5715rem] ml-[-0.4715rem]": props2.orientation === "vertical"
              }
            )
          })
        }
      }
    ),
    /* @__PURE__ */ jsxs22("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx35("span", { children: props.min }),
      /* @__PURE__ */ jsx35("span", { children: props.max })
    ] })
  ] });
}

// src/pages/new-grid/components/step-1/index.tsx
import { Controller, useForm } from "react-hook-form";

// src/pages/new-grid/components/footer/index.tsx
import { Button as Button2, Loading as Loading5 } from "@oppy/omniv2-ui";
import { useNavigate as useNavigate2, useParams as useParams3 } from "react-router-dom";
import { jsx as jsx36, jsxs as jsxs23 } from "react/jsx-runtime";
function Footer({
  canGoNext,
  canGoBack,
  onNextButtonClick,
  onBackButtonClick,
  nextButtonLabel = "Suivant",
  isPending
}) {
  const { gridType } = useNewGridStore();
  const navigate = useNavigate2();
  const { entityId } = useParams3();
  return /* @__PURE__ */ jsxs23("footer", { className: "flex gap-4", children: [
    canGoBack && /* @__PURE__ */ jsxs23(Button2, { disabled: !canGoNext, onClick: onBackButtonClick, children: [
      !isPending && "Retour",
      isPending && /* @__PURE__ */ jsx36(Loading5, {})
    ] }),
    /* @__PURE__ */ jsxs23(
      Button2,
      {
        type: onNextButtonClick ? "button" : "submit",
        disabled: !canGoNext,
        onClick: onNextButtonClick,
        children: [
          !isPending && nextButtonLabel,
          isPending && /* @__PURE__ */ jsx36(Loading5, {})
        ]
      }
    ),
    /* @__PURE__ */ jsx36(
      Button2,
      {
        variant: "secondary",
        onClick: () => navigate("/" + entityId + BACK_HREF_MAPPING[gridType]),
        disabled: isPending,
        children: "Annuler"
      }
    )
  ] });
}

// src/pages/new-grid/components/step-1/step-1.config.ts
import { z } from "zod";
var CreateGridStep1Schema = z.object({
  gridName: z.string().min(2),
  description: z.string().optional(),
  hasSegment: z.boolean().optional(),
  hasSummary: z.boolean().optional(),
  summaryPrompt: z.string().optional(),
  segment: z.object({
    min: z.number().optional(),
    max: z.number().optional()
  }).optional()
});

// src/pages/new-grid/components/step-1/index.tsx
import { Fragment as Fragment9, jsx as jsx37, jsxs as jsxs24 } from "react/jsx-runtime";
var DEFAULT_SEGMENT_MIN = 40;
var DEFAULT_SEGMENT_MAX = 45;
var SUMMARY_PLACEHOLDER = 'Param\xE8tre de votre r\xE9sum\xE9 (exemple : "je veux un r\xE9sum\xE9 de 2000 caract\xE8res max", "r\xE9cup\xE8re les points \xE0 travailler pour ce collaborateur", ...)';
function Step1() {
  const { nextStep } = useStepperContext();
  const { setData, data } = useNewGridStore();
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    setValue,
    getValues,
    trigger
  } = useForm({
    resolver: zodResolver(CreateGridStep1Schema),
    values: {
      ...data.step1,
      gridName: data.step1?.gridName || ""
    }
  });
  const onSubmit = handleSubmit((step1) => {
    setData({ step1 });
    nextStep();
  });
  useStepperHandle({
    onChangeStep: async () => {
      await onSubmit();
      return trigger();
    }
  });
  return /* @__PURE__ */ jsx37("form", { onSubmit, children: /* @__PURE__ */ jsxs24(Section, { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx37(Heading16, { children: "Nom" }),
    /* @__PURE__ */ jsx37(
      Controller,
      {
        name: "gridName",
        control,
        render: ({ field }) => /* @__PURE__ */ jsx37(
          Input,
          {
            type: "text",
            placeholder: "Nom de la grille (obligatoire)",
            helperText: "Exemple : Normandie",
            className: "w-full",
            onChange: (event) => field.onChange(event),
            invalid: !!errors.gridName,
            required: true,
            value: field.value
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs24("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ jsx37(
        Controller,
        {
          name: "description",
          control,
          render: ({ field }) => /* @__PURE__ */ jsx37(
            Input,
            {
              placeholder: "Informations compl\xE9mentaires",
              helperText: "Exemple : Respect du process",
              className: "w-full",
              onChange: (event) => field.onChange(event.currentTarget.value),
              invalid: !!errors.description,
              value: field.value
            }
          )
        }
      ),
      /* @__PURE__ */ jsxs24("span", { className: "text-xs", children: [
        "Ajoutez un contexte pour pr\xE9ciser le besoin (exemple : j",
        "'",
        "ai besoin de mieux comprendre ma cible r\xE9gionale)"
      ] })
    ] }),
    /* @__PURE__ */ jsxs24("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ jsxs24(Heading16, { children: [
        "Param\xE8tres l",
        "'",
        "indicateur de conformit\xE9"
      ] }),
      /* @__PURE__ */ jsx37(Heading22, { withOpacity: true, className: "text-text-secondary", children: "D\xE9finissez la zone de conformit\xE9, ce qui se trouve avant le curseur est jug\xE9 non conforme" })
    ] }),
    /* @__PURE__ */ jsx37(
      Controller,
      {
        name: "hasSegment",
        control,
        render: ({ field }) => /* @__PURE__ */ jsxs24(Fragment9, { children: [
          /* @__PURE__ */ jsx37(
            Switch,
            {
              checked: field.value || false,
              onChange: (event) => field.onChange(event.value),
              label: "D\xE9finition d'un segment de conformit\xE9 partielle"
            }
          ),
          field.value && /* @__PURE__ */ jsx37("div", { className: "md:w-1/2", children: /* @__PURE__ */ jsx37(
            Controller,
            {
              name: "segment",
              control,
              render: () => {
                const segmentValues = getValues("segment");
                return /* @__PURE__ */ jsx37(
                  DoubleSlider,
                  {
                    value: [
                      segmentValues?.min || DEFAULT_SEGMENT_MIN,
                      segmentValues?.max || DEFAULT_SEGMENT_MAX
                    ],
                    onChange: (event) => {
                      if (typeof event.value === "number") return;
                      let [min, max] = event.value;
                      if (min > max) {
                        const tempMax = max;
                        max = min;
                        min = tempMax;
                      }
                      setValue("segment", { min, max });
                    },
                    min: 0,
                    max: 100,
                    step: 10
                  }
                );
              }
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ jsx37(
      Controller,
      {
        name: "hasSummary",
        control,
        render: ({ field }) => /* @__PURE__ */ jsxs24(Fragment9, { children: [
          /* @__PURE__ */ jsx37(
            Switch,
            {
              checked: field.value || false,
              onChange: (event) => field.onChange(event.value),
              label: "D\xE9finition d'un r\xE9sum\xE9"
            }
          ),
          field.value && /* @__PURE__ */ jsx37(
            Controller,
            {
              name: "summaryPrompt",
              control,
              render: ({ field: textAreaField }) => /* @__PURE__ */ jsx37(
                TextArea,
                {
                  value: textAreaField.value || "",
                  onChange: (event) => textAreaField.onChange(event),
                  placeholder: SUMMARY_PLACEHOLDER
                }
              )
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsx37(Footer, { canGoNext: isValid })
  ] }) });
}

// src/pages/new-grid/components/step-2/index.tsx
import {
  AppLink as AppLink4,
  Button as Button4,
  cn as cn9,
  CustomIcon as CustomIcon3,
  faPlusCircle as faPlusCircle2,
  faUpload,
  Heading1 as Heading17,
  Icon as Icon14,
  Table as Table2,
  useStepperContext as useStepperContext2,
  useStepperHandle as useStepperHandle2,
  useToastContext as useToastContext2
} from "@oppy/omniv2-ui";
import { sortByKey } from "@oppy/omniv2-utils";
import Papa from "papaparse";
import { useRef as useRef5, useState as useState6 } from "react";

// src/pages/new-grid/components/new-phase/index.tsx
import { zodResolver as zodResolver2 } from "@hookform/resolvers/zod";
import {
  Button as Button3,
  Dialog,
  Heading2 as Heading23,
  Input as Input2,
  Select,
  Switch as Switch2
} from "@oppy/omniv2-ui";
import { useState as useState5 } from "react";
import { Controller as Controller3, useForm as useForm2 } from "react-hook-form";

// src/pages/new-grid/components/criteria-tab/index.tsx
import {
  faHandshakeSimple,
  faThumbsDown as faThumbsDown3,
  faThumbsUp as faThumbsUp2,
  faTimes as faTimes4,
  Icon as Icon13,
  Tab
} from "@oppy/omniv2-ui";

// src/pages/new-grid/components/criteria-form/index.tsx
import { TextArea as TextArea2 } from "@oppy/omniv2-ui";
import { Controller as Controller2 } from "react-hook-form";
import { jsx as jsx38, jsxs as jsxs25 } from "react/jsx-runtime";
var CONTEXT_LABEL_MAPPING = {
  compliant: "Contexte de conformit\xE9",
  partiallyCompliant: "Contexte de conformit\xE9 partielle",
  nonCompliant: "Contexte de non conformit\xE9",
  nonApplicable: "Contexte de conformit\xE9 non applicable"
};
function CriteriaForm({ control, errors, formKind }) {
  return /* @__PURE__ */ jsxs25("div", { "data-testid": "criteria-form", children: [
    /* @__PURE__ */ jsx38("div", { className: "flex items-center gap-4", children: /* @__PURE__ */ jsxs25("div", { className: "flex-1 text-sm", children: [
      /* @__PURE__ */ jsx38("p", { className: "font-semibold", children: "Quelles sont les conditions de ce crit\xE8re ?" }),
      /* @__PURE__ */ jsxs25("p", { children: [
        "Le score d\xE9termine l",
        "'",
        "impact sur la note globale"
      ] })
    ] }) }),
    /* @__PURE__ */ jsx38("div", { className: "mt-4", children: /* @__PURE__ */ jsx38(
      Controller2,
      {
        name: `${formKind}.context`,
        control,
        render: ({ field }) => /* @__PURE__ */ jsx38(
          TextArea2,
          {
            value: field.value || "",
            onChange: (event) => field.onChange(event),
            error: errors[formKind]?.context?.message,
            placeholder: CONTEXT_LABEL_MAPPING[formKind]
          }
        )
      }
    ) })
  ] });
}

// src/pages/new-grid/components/criteria-tab/index.tsx
import { jsx as jsx39, jsxs as jsxs26 } from "react/jsx-runtime";
function CriteriaTab(props) {
  return /* @__PURE__ */ jsx39(
    Tab,
    {
      items: [
        {
          header: /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx39(Icon13, { icon: faThumbsUp2, className: "size-4" }),
            " Conforme"
          ] }),
          children: /* @__PURE__ */ jsx39(CriteriaForm, { ...props, formKind: "compliant" })
        },
        {
          header: /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx39(Icon13, { icon: faHandshakeSimple, className: "size-4" }),
            " Partielement conforme"
          ] }),
          children: /* @__PURE__ */ jsx39(CriteriaForm, { ...props, formKind: "partiallyCompliant" })
        },
        {
          header: /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx39(Icon13, { icon: faThumbsDown3, className: "size-4" }),
            " Non conforme"
          ] }),
          children: /* @__PURE__ */ jsx39(CriteriaForm, { ...props, formKind: "nonCompliant" })
        },
        {
          header: /* @__PURE__ */ jsxs26("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx39(Icon13, { icon: faTimes4, className: "size-4" }),
            " Non applicable"
          ] }),
          children: /* @__PURE__ */ jsx39(CriteriaForm, { ...props, formKind: "nonApplicable" })
        }
      ]
    }
  );
}

// src/pages/new-grid/components/new-phase/new-phase.config.ts
import { z as z2 } from "zod";
var NewPhaseSchema = z2.object({
  category: z2.object({
    label: z2.string().min(2, { message: "Champ obligatoire" }).trim()
  }),
  criteria: z2.string().min(2, { message: "Champ obligatoire" }).trim(),
  invalidate: z2.boolean().optional(),
  position: z2.number().min(0).optional(),
  maxScore: z2.number().multipleOf(0.01).min(1).max(100),
  compliant: z2.object({
    enabled: z2.boolean().optional(),
    context: z2.string().trim().optional()
  }).optional(),
  partiallyCompliant: z2.object({
    enabled: z2.boolean().optional(),
    context: z2.string().trim().optional().nullable()
  }).optional(),
  nonCompliant: z2.object({
    enabled: z2.boolean().optional().nullable(),
    context: z2.string().trim().optional().nullable()
  }).optional().nullable(),
  nonApplicable: z2.object({
    enabled: z2.boolean().optional().nullable(),
    context: z2.string().trim().optional().nullable()
  }).optional().nullable()
});

// src/pages/new-grid/components/new-phase/index.tsx
import { jsx as jsx40, jsxs as jsxs27 } from "react/jsx-runtime";
var NEW_CATEGORY_LABEL = "Nouvelle cat\xE9gorie...";
var FORM_ID = "form-new-phase";
var DUMMY_PHASE = { maxScore: 1 };
function NewPhase() {
  const [tempCategory, setTempCategory] = useState5(NEW_CATEGORY_LABEL);
  const {
    addPhase,
    toggleNewPhaseModalOpen,
    availableCategories,
    phasePositionToEdit,
    data: { phases }
  } = useNewGridStore();
  const phaseToEdit = phases.find(
    (item) => item.position === phasePositionToEdit
  );
  const {
    handleSubmit,
    formState: { errors, isValid },
    control
  } = useForm2({
    resolver: zodResolver2(NewPhaseSchema),
    defaultValues: phaseToEdit || DUMMY_PHASE
  });
  return /* @__PURE__ */ jsx40(
    Dialog,
    {
      visible: true,
      header: "Crit\xE8re d'\xE9valuation",
      onHide: () => {
        toggleNewPhaseModalOpen(false);
      },
      children: /* @__PURE__ */ jsxs27("form", { id: FORM_ID, onSubmit: handleSubmit(addPhase), children: [
        /* @__PURE__ */ jsx40("div", { className: "mb-4", children: /* @__PURE__ */ jsxs27(Heading23, { className: "text-secondary/70", children: [
          "Modifiez les param\xE8tres de votre phase d",
          "'",
          "\xE9valuation"
        ] }) }),
        /* @__PURE__ */ jsxs27("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ jsxs27("div", { "data-testid": "select-category", children: [
            /* @__PURE__ */ jsx40(
              Controller3,
              {
                name: "category",
                control,
                render: ({ field }) => /* @__PURE__ */ jsx40(
                  Select,
                  {
                    editable: true,
                    placeholder: "Ajouter ou cr\xE9er une cat\xE9gorie...",
                    options: [...availableCategories, { label: tempCategory }],
                    optionLabel: "label",
                    value: field.value,
                    onChange: (event) => {
                      const value = event.value || " ";
                      const isNewCategoryMode = typeof event.value === "string";
                      if (isNewCategoryMode) {
                        setTempCategory(value);
                      }
                      field.onChange(
                        isNewCategoryMode ? { label: value } : value
                      );
                    }
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx40("p", { className: "mt-2 text-xs text-secondary", children: "Une cat\xE9gorie sera cr\xE9\xE9e en enregistrant ce mod\xE8le" })
          ] }),
          /* @__PURE__ */ jsx40(
            Controller3,
            {
              name: "criteria",
              control,
              render: ({ field }) => /* @__PURE__ */ jsx40(
                Input2,
                {
                  className: "w-full",
                  placeholder: "Crit\xE8re",
                  value: field.value,
                  onChange: (event) => field.onChange(event.currentTarget.value),
                  invalid: !!errors.criteria,
                  required: true
                }
              )
            }
          ),
          /* @__PURE__ */ jsx40(
            Controller3,
            {
              name: "invalidate",
              control,
              render: ({ field }) => /* @__PURE__ */ jsx40(
                Switch2,
                {
                  label: "Rendre la non conformit\xE9 invalidante",
                  checked: field.value || false,
                  onChange: (event) => field.onChange(event.value)
                }
              )
            }
          ),
          /* @__PURE__ */ jsx40("div", { children: /* @__PURE__ */ jsx40(
            Controller3,
            {
              name: "maxScore",
              control,
              render: ({ field }) => /* @__PURE__ */ jsx40(
                Input2,
                {
                  className: "w-[50px]",
                  value: field.value?.toString(),
                  placeholder: "Score",
                  type: "number",
                  onChange: (event) => field.onChange(+event.currentTarget.value),
                  invalid: !!errors?.maxScore,
                  required: true,
                  step: 0.1,
                  min: 0,
                  max: 100
                }
              )
            }
          ) }),
          /* @__PURE__ */ jsx40(CriteriaTab, { errors, control })
        ] }),
        /* @__PURE__ */ jsxs27("div", { className: "flex gap-4", children: [
          /* @__PURE__ */ jsx40(Button3, { type: "submit", form: FORM_ID, disabled: !isValid, children: "Ajouter" }),
          /* @__PURE__ */ jsx40(
            Button3,
            {
              variant: "secondary",
              onClick: () => toggleNewPhaseModalOpen(false),
              children: "Annuler"
            }
          )
        ] })
      ] })
    }
  );
}

// src/pages/new-grid/components/phase-popup-menu/index.tsx
import { buttonTemplate, faPen, faTrash, PopupMenu as PopupMenu2 } from "@oppy/omniv2-ui";
import { jsx as jsx41 } from "react/jsx-runtime";
function PhasePopupMenu({ position }) {
  const { removePhase, toggleNewPhaseModalOpen } = useNewGridStore();
  if (!position) return null;
  return /* @__PURE__ */ jsx41(
    PopupMenu2,
    {
      items: [
        buttonTemplate({
          label: "Modifier",
          icon: faPen,
          onClick: () => toggleNewPhaseModalOpen(true, position)
        }),
        buttonTemplate({
          label: "Supprimer",
          icon: faTrash,
          color: "delete",
          onClick: () => removePhase(position)
        })
      ]
    }
  );
}

// src/pages/new-grid/components/step-2/index.tsx
import { Fragment as Fragment10, jsx as jsx42, jsxs as jsxs28 } from "react/jsx-runtime";
var DEFAULT_SORT = {
  field: "position",
  direction: "asc"
};
function Step2() {
  const { nextStep, prevStep } = useStepperContext2();
  const inputFileRef = useRef5(null);
  const {
    data: { step1, phases },
    isNewPhaseModalOpen,
    toggleNewPhaseModalOpen,
    addPhase
  } = useNewGridStore();
  const hasAtLeastOnePhase = phases.length > 0;
  const [sort, setSort] = useState6(DEFAULT_SORT);
  const { showMessage } = useToastContext2();
  const sorted = sortByKey(phases, sort.field, sort.direction);
  useStepperHandle2({
    onChangeStep: () => hasAtLeastOnePhase
  });
  return /* @__PURE__ */ jsxs28(
    Section,
    {
      className: cn9("flex flex-col gap-4 justify-between", {
        "min-h-[408px]": !isNewPhaseModalOpen,
        "min-h-[70vh]": isNewPhaseModalOpen
      }),
      children: [
        isNewPhaseModalOpen && /* @__PURE__ */ jsx42(NewPhase, {}),
        !isNewPhaseModalOpen && /* @__PURE__ */ jsxs28(Fragment10, { children: [
          /* @__PURE__ */ jsxs28("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsxs28(Heading17, { children: [
              "Grille ",
              step1?.gridName
            ] }),
            /* @__PURE__ */ jsxs28("div", { className: "flex items-center gap-6", children: [
              /* @__PURE__ */ jsxs28(
                AppLink4,
                {
                  to: "#",
                  onClick: (event) => {
                    event.preventDefault();
                    inputFileRef.current?.click();
                  },
                  className: "flex items-center gap-2 text-primary",
                  children: [
                    /* @__PURE__ */ jsx42(Icon14, { icon: faUpload }),
                    "Charger"
                  ]
                }
              ),
              /* @__PURE__ */ jsx42(
                "input",
                {
                  ref: inputFileRef,
                  type: "file",
                  className: "hidden",
                  accept: ".csv",
                  value: "",
                  onChange: (event) => {
                    const file = event.currentTarget?.files?.[0];
                    if (!file) return;
                    Papa.parse(file, {
                      header: true,
                      dynamicTyping: true,
                      skipEmptyLines: true,
                      complete: (results) => {
                        const jsonData = results.data;
                        if (jsonData.some(
                          (row) => row["Position (Obligatoire)"] === void 0 || row["Position (Obligatoire)"] < 0
                        )) {
                          showMessage({
                            severity: "error",
                            summary: "Erreur...",
                            detail: "La position est obligatoire"
                          });
                          return;
                        }
                        if (jsonData.some((row) => !row["Categorie (Obligatoire)"])) {
                          showMessage({
                            severity: "error",
                            summary: "Erreur...",
                            detail: "La cat\xE9gorie est obligatoire"
                          });
                          return;
                        }
                        if (jsonData.some((row) => !row["Critere (Obligatoire)"])) {
                          showMessage({
                            severity: "error",
                            summary: "Erreur...",
                            detail: "Le critere est obligatoire"
                          });
                          return;
                        }
                        if (jsonData.some(
                          (row) => !row["Prompt : Conforme (Obligatoire)"]
                        )) {
                          showMessage({
                            severity: "error",
                            summary: "Erreur...",
                            detail: 'Le prompt "conforme" est obligatoire'
                          });
                          return;
                        }
                        if (jsonData.some((row) => row["Score (Obligatoire)"] <= 0)) {
                          showMessage({
                            severity: "error",
                            summary: "Erreur...",
                            detail: "Le score doit \xEAtre strictement sup\xE9rieur \xE0 0"
                          });
                          return;
                        }
                        jsonData.map((row) => {
                          addPhase({
                            category: { label: row["Categorie (Obligatoire)"] },
                            criteria: row["Critere (Obligatoire)"],
                            invalidate: row["Invalidante (Obligatoire)"] === "true" || row["Invalidante (Obligatoire)"] == "1",
                            position: row["Position (Obligatoire)"],
                            compliant: {
                              enabled: true,
                              context: row["Prompt : Conforme (Obligatoire)"]
                            },
                            nonApplicable: {
                              enabled: true,
                              context: row["Prompt : Non Applicable"]
                            },
                            nonCompliant: {
                              enabled: true,
                              context: row["Prompt : Non Conforme"]
                            },
                            partiallyCompliant: {
                              enabled: true,
                              context: row["Prompt : Partiellement Conforme"]
                            },
                            maxScore: row["Score (Obligatoire)"]
                          });
                        });
                      },
                      error: (error) => {
                        showMessage({
                          severity: "error",
                          summary: "Impossible de charger le fichier",
                          detail: error.message
                        });
                      }
                    });
                  }
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsx42(
            Table2,
            {
              columns: [
                {
                  field: "position",
                  header: "Position",
                  sortable: true,
                  bodyClassName: "w-10",
                  headerClassName: "px-2"
                },
                {
                  field: "category",
                  header: "Cat\xE9gorie",
                  sortable: true,
                  sortField: "category.label",
                  body: (phase) => phase.category.label,
                  headerClassName: "px-2"
                },
                {
                  field: "criteria",
                  header: "Crit\xE8re",
                  body: (phase) => /* @__PURE__ */ jsx42(
                    "p",
                    {
                      className: "overflow-hidden truncate pr-2",
                      title: phase.criteria,
                      children: phase.criteria
                    }
                  ),
                  bodyClassName: "px-2 w-[220px] max-w-[220px] overflow-hidden",
                  headerClassName: "px-2"
                },
                {
                  field: "compliant",
                  header: /* @__PURE__ */ jsx42(CustomIcon3, { name: "THUMBS_UP", className: "size-4" }),
                  body: (phase) => /* @__PURE__ */ jsx42(
                    "input",
                    {
                      type: "checkbox",
                      checked: phase.compliant?.enabled || false,
                      disabled: true
                    }
                  ),
                  bodyClassName: "w-8"
                },
                {
                  field: "partiallyCompliant",
                  header: /* @__PURE__ */ jsx42(CustomIcon3, { name: "THUMBS_UP_DONW", className: "size-4" }),
                  body: (phase) => /* @__PURE__ */ jsx42(
                    "input",
                    {
                      type: "checkbox",
                      checked: phase.partiallyCompliant?.enabled || false,
                      disabled: true
                    }
                  ),
                  bodyClassName: "w-8"
                },
                {
                  field: "nonCompliant",
                  header: /* @__PURE__ */ jsx42(CustomIcon3, { name: "THUMBS_DONW", className: "size-4" }),
                  body: (phase) => /* @__PURE__ */ jsx42(
                    "input",
                    {
                      type: "checkbox",
                      checked: phase.nonCompliant?.enabled || false,
                      disabled: true
                    }
                  ),
                  bodyClassName: "w-8"
                },
                {
                  field: "nonApplicable",
                  header: /* @__PURE__ */ jsx42(CustomIcon3, { name: "TIMES_HEXAGON", className: "size-4" }),
                  body: (phase) => /* @__PURE__ */ jsx42(
                    "input",
                    {
                      type: "checkbox",
                      checked: phase.nonApplicable?.enabled || false,
                      disabled: true
                    }
                  ),
                  bodyClassName: "w-8"
                },
                {
                  field: "invalidate",
                  header: "Invalidant",
                  align: "center",
                  body: ({ invalidate }) => invalidate ? "Oui" : "Non",
                  bodyClassName: "text-center",
                  headerClassName: "px-2"
                },
                { field: "maxScore", header: "Score", headerClassName: "px-2" },
                {
                  field: "menu",
                  header: "",
                  body: PhasePopupMenu
                }
              ],
              value: sorted,
              paginator: false,
              onSort: (event) => {
                setSort({
                  field: event.sortField,
                  direction: event.sortOrder === 1 ? "asc" : "desc"
                });
              },
              sortField: sort.field,
              sortOrder: sort.direction === "asc" ? 1 : -1
            }
          ),
          /* @__PURE__ */ jsxs28(
            Button4,
            {
              variant: "text",
              type: "button",
              onClick: () => toggleNewPhaseModalOpen(true),
              children: [
                /* @__PURE__ */ jsx42(Icon14, { icon: faPlusCircle2 }),
                " Ajouter une nouvelle phase"
              ]
            }
          ),
          /* @__PURE__ */ jsx42(
            Footer,
            {
              canGoNext: hasAtLeastOnePhase,
              onNextButtonClick: nextStep,
              onBackButtonClick: prevStep,
              canGoBack: true
            }
          )
        ] })
      ]
    }
  );
}

// src/pages/new-grid/components/step-3/index.tsx
import {
  Button as Button5,
  faDownload,
  faPlusCircle as faPlusCircle3,
  faUpload as faUpload2,
  faWarning as faWarning2,
  Heading1 as Heading18,
  Icon as Icon15,
  IconButton,
  Input as Input3,
  PrimeColorPicker,
  Table as Table3,
  useStepperContext as useStepperContext3,
  useToastContext as useToastContext3
} from "@oppy/omniv2-ui";
import { useMutation as useMutation2, useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import { useNavigate as useNavigate3, useParams as useParams4 } from "react-router-dom";

// src/pages/new-grid/components/tag-popup-menu/index.tsx
import { buttonTemplate as buttonTemplate2, faTrash as faTrash2, PopupMenu as PopupMenu3 } from "@oppy/omniv2-ui";
import { jsx as jsx43 } from "react/jsx-runtime";
function TagPopupMenu(tag) {
  const { removeTag } = useNewGridStore();
  return /* @__PURE__ */ jsx43(
    PopupMenu3,
    {
      items: [
        buttonTemplate2({
          label: "Supprimer",
          color: "delete",
          onClick: () => removeTag(tag),
          icon: faTrash2
        })
      ]
    }
  );
}

// src/pages/new-grid/components/step-3/index.tsx
import { Fragment as Fragment11, jsx as jsx44, jsxs as jsxs29 } from "react/jsx-runtime";
var CAN_IMPORT_EXPORT = false;
function Step3() {
  const queryClient = useQueryClient2();
  const navigate = useNavigate3();
  const { showMessage } = useToastContext3();
  const { entityId = "" } = useParams4();
  const { prevStep } = useStepperContext3();
  const {
    gridType,
    data: { gridIdToUpdate, step1, tags, phases },
    addEmptyTag,
    updateTag
  } = useNewGridStore();
  const isUpdateMode = !!gridIdToUpdate;
  const { mutate, isPending, error } = useMutation2({
    mutationFn: createOrUpdateGrid,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FETCH_GRIDS_QUERY_KEY] });
      navigate("/" + entityId + BACK_HREF_MAPPING[gridType]);
      showMessage({
        severity: "success",
        summary: "Succ\xE8s !",
        detail: /* @__PURE__ */ jsxs29(Fragment11, { children: [
          "La grille ",
          /* @__PURE__ */ jsx44("b", { children: step1?.gridName }),
          " a bien \xE9t\xE9",
          " ",
          isUpdateMode ? "modifi\xE9e" : "cr\xE9\xE9e",
          "."
        ] })
      });
    },
    onError: (error2) => {
      showMessage({
        severity: "error",
        summary: "Erreur...",
        detail: error2.message
      });
    }
  });
  if (!step1) return null;
  return /* @__PURE__ */ jsxs29(Section, { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsxs29("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs29(Heading18, { children: [
        "Tags ",
        step1.gridName
      ] }),
      CAN_IMPORT_EXPORT && /* @__PURE__ */ jsxs29("div", { className: "flex gap-6", children: [
        /* @__PURE__ */ jsx44(IconButton, { iconProps: { icon: faDownload }, children: "T\xE9l\xE9charger" }),
        /* @__PURE__ */ jsx44(IconButton, { iconProps: { icon: faUpload2 }, children: "Charger" })
      ] })
    ] }),
    /* @__PURE__ */ jsx44(
      Table3,
      {
        editMode: "cell",
        columns: [
          {
            field: "label",
            header: "Libell\xE9",
            editor: (options) => /* @__PURE__ */ jsx44(
              Input3,
              {
                value: options.value,
                className: "w-full",
                onChange: ({ currentTarget }) => options.editorCallback?.(currentTarget.value)
              }
            ),
            onCellEditComplete: (event) => {
              updateTag(event.rowIndex, event.newRowData);
            }
          },
          {
            field: "criteria",
            header: "Crit\xE8res d'affectation",
            editor: (options) => /* @__PURE__ */ jsx44(
              Input3,
              {
                value: options.value,
                className: "w-full",
                onChange: ({ currentTarget }) => options.editorCallback?.(currentTarget.value)
              }
            ),
            onCellEditComplete: (event) => {
              updateTag(event.rowIndex, event.newRowData);
            }
          },
          {
            field: "color",
            header: "Couleur",
            body: ({ color }) => /* @__PURE__ */ jsx44(PrimeColorPicker, { value: color }),
            editor: (options) => /* @__PURE__ */ jsx44(
              PrimeColorPicker,
              {
                value: options.value,
                onChange: (event) => options.editorCallback?.(`#${event.value}`)
              }
            ),
            onCellEditComplete: (event) => {
              updateTag(event.rowIndex, event.newRowData);
            }
          },
          {
            field: "menu",
            header: "",
            body: TagPopupMenu
          }
        ],
        value: tags,
        paginator: false
      }
    ),
    /* @__PURE__ */ jsxs29(Button5, { variant: "text", onClick: addEmptyTag, disabled: isPending, children: [
      /* @__PURE__ */ jsx44(Icon15, { icon: faPlusCircle3 }),
      " Ajouter un tag"
    ] }),
    error && /* @__PURE__ */ jsxs29("p", { className: "my-4 text-error", children: [
      /* @__PURE__ */ jsx44(Icon15, { icon: faWarning2 }),
      " ",
      error.message
    ] }),
    /* @__PURE__ */ jsx44(
      Footer,
      {
        canGoNext: !isPending,
        canGoBack: true,
        isPending,
        nextButtonLabel: "Terminer",
        onBackButtonClick: prevStep,
        onNextButtonClick: () => {
          const totalMaxScore = phases.reduce(
            (prev, curr) => prev + curr.maxScore,
            0
          );
          const data = {
            id: gridIdToUpdate,
            gridType: isUpdateMode ? void 0 : gridType,
            name: step1.gridName,
            description: step1.description,
            totalMaxScore,
            minPartialScore: step1.segment?.min,
            maxPartialScore: step1.segment?.max,
            summaryPrompt: step1.summaryPrompt,
            criteria: phases.map((item) => ({
              category: item.category.label,
              name: item.criteria,
              maxScore: item.maxScore,
              compliantReason: item.compliant?.context,
              partialReason: item.partiallyCompliant?.context,
              nonCompliantReason: item.nonCompliant?.context,
              nonApplicableReason: item.nonApplicable?.context,
              mustBeSatisfied: item.invalidate || false
            })),
            tags: tags.map((tag) => ({
              name: tag.label,
              triggerCriterion: tag.criteria,
              color: tag.color
            })),
            isActive: true
          };
          mutate({ entityId, data });
        }
      }
    )
  ] });
}

// src/pages/new-grid/new-grid.config.ts
var BACK_HREF_MAPPING = {
  SalesCompliant: "/sales-compliant/settings",
  QualityMonitoring: "/quality-monitoring/settings"
};
var buildStepItems = function() {
  return [
    {
      header: {
        title: "G\xE9n\xE9ral",
        subtitle: "Identifier votre grille"
      },
      content: Step1
    },
    {
      header: {
        title: "Grille",
        subtitle: "Cr\xE9er des crit\xE8res"
      },
      content: Step2
    },
    { header: { title: "Tags", subtitle: "Ajoutez des tags" }, content: Step3 }
  ];
};
function useData(gridType) {
  const navigate = useNavigate4();
  const { clear } = useNewGridStore();
  const { entityId } = useParams5();
  const handleOnClose = useCallback2(() => {
    clear();
    navigate("/" + entityId + BACK_HREF_MAPPING[gridType] || "/");
  }, [gridType, navigate, entityId, clear]);
  useEffect5(() => {
    if (!gridType) {
      handleOnClose();
    }
  }, [gridType, handleOnClose]);
  return {
    handleOnClose,
    stepItems: buildStepItems()
  };
}

// src/pages/new-grid/index.tsx
import { jsx as jsx45, jsxs as jsxs30 } from "react/jsx-runtime";
var KEY_UPDATE_GRID_ID = "updateGridId";
function NewGrid({ gridType }) {
  const { entityId } = useEntity5();
  const { init, initialized } = useNewGridStore();
  const { handleOnClose, stepItems } = useData(gridType);
  const [searchParams] = useSearchParams2();
  const gridIdToUpdate = searchParams.get(KEY_UPDATE_GRID_ID);
  const isEditMode = !!gridIdToUpdate;
  const { data: potentialGridToUpdate, isPending } = useQuery5({
    staleTime: 0,
    queryKey: ["findGridById", entityId, gridIdToUpdate],
    queryFn: () => findGridById(entityId, gridIdToUpdate).catch((error) => {
      handleOnClose();
      throw error;
    }),
    enabled: !!gridIdToUpdate
  });
  const gridIsLoading = !!gridIdToUpdate && isPending;
  useEffect6(() => {
    if (gridIsLoading) return;
    init(gridType, potentialGridToUpdate);
  }, [init, potentialGridToUpdate, gridIsLoading, gridType]);
  return /* @__PURE__ */ jsxs30("div", { className: "flex flex-col gap-4", children: [
    (!initialized || gridIsLoading) && /* @__PURE__ */ jsx45(Loading6, {}),
    initialized && !gridIsLoading && /* @__PURE__ */ jsx45(
      Stepper,
      {
        title: isEditMode ? "Modification d'une grille" : "Nouvelle grille d'\xE9valuation",
        headerTemplate: HeaderStepperTemplate,
        items: stepItems,
        linear: !isEditMode
      }
    )
  ] });
}

// src/pages/quality-monitoring-dashboard/index.tsx
import { Heading1 as Heading113, Loading as Loading10 } from "@oppy/omniv2-ui";
import { useEffect as useEffect8 } from "react";
import { useSearchParams as useSearchParams5 } from "react-router-dom";

// src/lib/core/store/quality-monitoring-stats-by-grid/index.ts
import { create as create7 } from "zustand";
var DEFAULT_STATE5 = {
  isLoading: true,
  results: void 0,
  areFiltersOpen: false
};
var useQualityMonitoringStatsByGridStore = create7(
  (set) => ({
    ...DEFAULT_STATE5,
    toggleFilters: () => {
      set((state) => ({ areFiltersOpen: !state.areFiltersOpen }));
    },
    closeFilters: () => {
      set({ areFiltersOpen: false });
    },
    openFilters: () => {
      set({ areFiltersOpen: true });
    },
    setStats: async (results) => {
      set({ results, isLoading: false });
    }
  })
);

// src/pages/quality-monitoring-dashboard/components/charts-container/index.tsx
import { useEntity as useEntity6 } from "@oppy/omniv2-entity";
import { useQuery as useQuery6 } from "@tanstack/react-query";
import { useSearchParams as useSearchParams3 } from "react-router-dom";

// src/lib/services/statistics.service.ts
import { omniApiClient as omniApiClient3 } from "@oppy/omniv2-core";
function getStatsForSalesCompliant(entityId) {
  const gridType = "SalesCompliant";
  return omniApiClient3.get(
    `${getBaseUrl(entityId)}evaluationGrids/statistics?gridType=${gridType}`
  );
}
function getStatsForSalesCompliantByGridId(entityId, searchParams) {
  const gridId = searchParams.get("gridId");
  const periodKey = searchParams.get("period") ?? DEFAULT_PERIOD.key;
  if (!gridId) throw new Error("ID de la grille obligatoire");
  const gridType = "SalesCompliant";
  const period = COMPUTE_PERIODS_MAPPING[periodKey]();
  const queryString = [
    `gridType=${gridType}`,
    `startAt=${formatDate2(period.from, true)}`,
    `endAt=${formatDate2(period.to, true)}`
  ].join("&");
  return omniApiClient3.get(
    `${getBaseUrl(entityId)}evaluationGrids/${gridId}/statistics?${queryString}`
  );
}
function getStatsForQualityMonitoring(entityId) {
  const gridType = "QualityMonitoring";
  return omniApiClient3.get(
    `${getBaseUrl(entityId)}evaluationGrids/statistics?gridType=${gridType}`
  );
}
function getStatsForQualityMonitoringByGridId(entityId, searchParams) {
  const gridId = searchParams.get("gridId");
  const periodKey = searchParams.get("period") ?? DEFAULT_PERIOD.key;
  if (!gridId) throw new Error("ID de la grille obligatoire");
  const gridType = "QualityMonitoring";
  const period = COMPUTE_PERIODS_MAPPING[periodKey]();
  const queryString = [
    `gridType=${gridType}`,
    `startAt=${formatDate2(period.from, true)}`,
    `endAt=${formatDate2(period.to, true)}`
  ].join("&");
  return omniApiClient3.get(
    `${getBaseUrl(entityId)}evaluationGrids/${gridId}/statistics?${queryString}`
  );
}

// src/pages/quality-monitoring-dashboard/components/chart-categories/index.tsx
import { Heading1 as Heading19, Loading as Loading7 } from "@oppy/omniv2-ui";

// src/pages/quality-monitoring-dashboard/components/chart-categories/chart-categories.config.ts
function useData2() {
  const { isLoading, results } = useQualityMonitoringStatsByGridStore();
  const labels = results?.scoreByCategories.map((item) => item.name) || [];
  const values = results?.scoreByCategories.map((item) => item.totalPercentageScore) || [];
  const chartProps = {
    labels,
    datasets: [{ label: "", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/quality-monitoring-dashboard/components/chart-categories/index.tsx
import { Fragment as Fragment12, jsx as jsx46, jsxs as jsxs31 } from "react/jsx-runtime";
function ChartCategories() {
  const { isLoading, chartProps } = useData2();
  return /* @__PURE__ */ jsxs31(Fragment12, { children: [
    /* @__PURE__ */ jsx46(Heading19, { children: "Note par cat\xE9gorie" }),
    isLoading && /* @__PURE__ */ jsx46(Loading7, { centered: true }),
    chartProps && /* @__PURE__ */ jsx46("div", { className: "flex h-[90%] w-full items-center justify-center overflow-hidden", children: /* @__PURE__ */ jsx46(ChartBarPercent, { data: chartProps }) })
  ] });
}

// src/pages/quality-monitoring-dashboard/components/chart-listenings-per-week/index.tsx
import { Heading1 as Heading110, Loading as Loading8 } from "@oppy/omniv2-ui";

// src/pages/quality-monitoring-dashboard/components/chart-listenings-per-week/chart-listenings-per-week.config.ts
function useData3() {
  const { isLoading, results } = useQualityMonitoringStatsByGridStore();
  const labels = results?.listensByDay?.map(({ date }) => date) || [];
  const values = results?.listensByDay?.map(({ listensCount }) => listensCount) || [];
  const chartProps = {
    labels,
    datasets: [{ label: "", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/quality-monitoring-dashboard/components/chart-listenings-per-week/index.tsx
import { Fragment as Fragment13, jsx as jsx47, jsxs as jsxs32 } from "react/jsx-runtime";
function ChartListeningPerWeek() {
  const { isLoading, chartProps } = useData3();
  return /* @__PURE__ */ jsxs32(Fragment13, { children: [
    /* @__PURE__ */ jsx47(Heading110, { children: "Nombre d'\xE9coutes sur la semaine" }),
    isLoading && /* @__PURE__ */ jsx47(Loading8, { centered: true }),
    chartProps && /* @__PURE__ */ jsx47(ChartLine, { data: chartProps })
  ] });
}

// src/pages/quality-monitoring-dashboard/components/chart-phases/index.tsx
import { Heading1 as Heading111, Loading as Loading9 } from "@oppy/omniv2-ui";

// src/pages/quality-monitoring-dashboard/components/chart-phases/chart-phases.config.ts
function useData4() {
  const { isLoading, results } = useQualityMonitoringStatsByGridStore();
  const labels = results?.scoreByCriterion.map((item) => item.name) || [];
  const values = results?.scoreByCriterion.map((item) => item.totalPercentageScore) || [];
  const chartProps = {
    labels,
    datasets: [{ label: "", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/quality-monitoring-dashboard/components/chart-phases/index.tsx
import { Fragment as Fragment14, jsx as jsx48, jsxs as jsxs33 } from "react/jsx-runtime";
function ChartePhases() {
  const { isLoading, chartProps } = useData4();
  return /* @__PURE__ */ jsxs33(Fragment14, { children: [
    /* @__PURE__ */ jsx48(Heading111, { children: "Note par phase" }),
    isLoading && /* @__PURE__ */ jsx48(Loading9, { centered: true }),
    chartProps && /* @__PURE__ */ jsx48("div", { className: "flex h-[90%] w-full items-center justify-center overflow-hidden", children: /* @__PURE__ */ jsx48(ChartBarPercent, { data: chartProps }) })
  ] });
}

// src/pages/quality-monitoring-dashboard/components/charts-container/index.tsx
import { jsx as jsx49, jsxs as jsxs34 } from "react/jsx-runtime";
function ChartsContainer() {
  const { entityId } = useEntity6();
  const { setStats } = useQualityMonitoringStatsByGridStore();
  const [searchParams] = useSearchParams3();
  useQuery6({
    queryKey: ["quality-monitoring-stats", entityId, searchParams.toString()],
    queryFn: () => {
      getStatsForQualityMonitoringByGridId(entityId, searchParams).then(
        setStats
      );
      return true;
    },
    enabled: searchParams.has("gridId")
  });
  return /* @__PURE__ */ jsxs34("div", { "data-testid": "charts-container", className: "grid grid-cols-12 gap-4", children: [
    /* @__PURE__ */ jsx49(Box, { className: "col-span-12 h-96", children: /* @__PURE__ */ jsx49(ChartCategories, {}) }),
    /* @__PURE__ */ jsx49(Box, { className: "col-span-12 h-96 md:col-span-6", children: /* @__PURE__ */ jsx49(ChartePhases, {}) }),
    /* @__PURE__ */ jsx49(Box, { className: "col-span-12 h-96 md:col-span-6", children: /* @__PURE__ */ jsx49(ChartListeningPerWeek, {}) })
  ] });
}

// src/pages/quality-monitoring-dashboard/components/filters/index.tsx
import { Button as Button6, Heading1 as Heading112, Select as Select2 } from "@oppy/omniv2-ui";
import { useEffect as useEffect7, useState as useState7 } from "react";
import { useSearchParams as useSearchParams4 } from "react-router-dom";
import { jsx as jsx50, jsxs as jsxs35 } from "react/jsx-runtime";
function Filters() {
  const { isLoading, toggleFilters } = useQualityMonitoringStatsByGridStore();
  const [searchParams, setSearchParams] = useSearchParams4();
  const { data: grids, isPending: isGridsPending } = useFetchGrids(
    "QualityMonitoring",
    {
      orderBy: "CreatedAt",
      sortDirection: "Descending",
      isActive: true
    }
  );
  const gridId = searchParams.get("gridId");
  const selectedGrid = grids?.find((grid) => grid.id === gridId) || grids?.[0];
  const period = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get("period")
  );
  const [tempGrid, setTempGrid] = useState7(selectedGrid);
  const [tempPeriod, setTempPeriod] = useState7(
    period || DEFAULT_PERIOD
  );
  useEffect7(() => {
    if (isGridsPending) return;
    setTempGrid(selectedGrid);
  }, [isGridsPending, selectedGrid]);
  return /* @__PURE__ */ jsxs35(Section, { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx50(Heading112, { children: "Filtres" }),
    /* @__PURE__ */ jsx50("hr", {}),
    /* @__PURE__ */ jsxs35("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ jsx50(
        Select2,
        {
          value: tempGrid,
          onChange: (event) => setTempGrid(event.value),
          options: grids,
          optionLabel: "name",
          placeholder: "Grille",
          disabled: isGridsPending || isLoading
        }
      ),
      /* @__PURE__ */ jsx50("div", { className: "h-full w-0.5 bg-slate-100", children: "\xA0" }),
      /* @__PURE__ */ jsx50("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx50(
        Select2,
        {
          value: tempPeriod,
          onChange: (event) => setTempPeriod(event.value),
          options: SEARCH_PERIODS,
          optionLabel: "name",
          placeholder: "P\xE9riode",
          disabled: isGridsPending || isLoading
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs35("div", { className: "flex items-center justify-center gap-4", children: [
      /* @__PURE__ */ jsx50(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "text-xs",
          onClick: () => {
            setSearchParams({}, { replace: true });
            toggleFilters();
          },
          children: "R\xE9initialiser les filtres"
        }
      ),
      /* @__PURE__ */ jsx50(
        Button6,
        {
          onClick: () => {
            if (tempGrid) {
              searchParams.set("gridId", tempGrid.id);
            }
            searchParams.set("period", tempPeriod.key);
            setSearchParams(searchParams, { replace: true });
            toggleFilters();
          },
          disabled: isGridsPending || isLoading,
          children: "Rechercher"
        }
      )
    ] })
  ] });
}

// src/pages/quality-monitoring-dashboard/components/stats-container/index.tsx
import { useEntity as useEntity7 } from "@oppy/omniv2-entity";
import { useQuery as useQuery7 } from "@tanstack/react-query";
import { Fragment as Fragment15, jsx as jsx51, jsxs as jsxs36 } from "react/jsx-runtime";
function StatsContainer() {
  const { entityId } = useEntity7();
  const { isLoading, data } = useQuery7({
    queryKey: ["getStatsForQualityMonitoring", entityId],
    queryFn: () => getStatsForQualityMonitoring(entityId)
  });
  return /* @__PURE__ */ jsxs36(
    "div",
    {
      "data-testid": "stats-container",
      className: "mt-10 grid grid-cols-12 gap-4",
      children: [
        isLoading && /* @__PURE__ */ jsxs36(Fragment15, { children: [
          /* @__PURE__ */ jsx51("div", { className: "col-span-3", children: /* @__PURE__ */ jsx51(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-3", children: /* @__PURE__ */ jsx51(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-3", children: /* @__PURE__ */ jsx51(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-3", children: /* @__PURE__ */ jsx51(CardStatsSkeleton, {}) })
        ] }),
        !isLoading && data && /* @__PURE__ */ jsxs36(Fragment15, { children: [
          /* @__PURE__ */ jsx51("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx51(
            CardStats,
            {
              title: "\xC9coutes",
              picto: "3d-woman-laptop",
              percentEvolution: data.listensStats?.evolutionPercentage,
              tag: "this-week",
              value: data.listensStats?.listensCount.toString()
            }
          ) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx51(
            CardStats,
            {
              title: "\xC9coutes \xE9valu\xE9es",
              picto: "3d-man-zoom",
              percentEvolution: data.evaluationsStats.evolutionPercentage,
              tag: "this-week",
              value: data.evaluationsStats.count.toString()
            }
          ) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx51(
            CardStats,
            {
              title: "Dur\xE9e moyenne",
              picto: "3d-man-smartphone",
              extra: "minutes",
              tag: "this-week",
              value: formatToKEuros(data.averageDurationInMinutes, false)
            }
          ) }),
          /* @__PURE__ */ jsx51("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx51(
            CardStats,
            {
              title: "Note globale",
              picto: "3d-man-crossed-arms",
              tag: "this-week",
              value: `${data.averageScorePercentage} %`
            }
          ) })
        ] })
      ]
    }
  );
}

// src/pages/quality-monitoring-dashboard/index.tsx
import { Fragment as Fragment16, jsx as jsx52, jsxs as jsxs37 } from "react/jsx-runtime";
var GRID_TYPE = "QualityMonitoring";
var PARAMS_KEY_GRID_ID = "gridId";
var PERIOD_KEY_PERIOD = "period";
function QualityMonitoringDashboard() {
  const [searchParams, setSearchParams] = useSearchParams5();
  const gridId = searchParams.get(PARAMS_KEY_GRID_ID);
  const period = searchParams.get(PERIOD_KEY_PERIOD);
  const { data: grids, isPending } = useFetchGrids(GRID_TYPE);
  const activeGrids = grids?.filter((a) => a.isActive);
  const grid = activeGrids?.find((grid2) => grid2.id === gridId) || activeGrids?.[0];
  const { areFiltersOpen, toggleFilters, isLoading } = useQualityMonitoringStatsByGridStore();
  useEffect8(() => {
    if (period) return;
    searchParams.set(PERIOD_KEY_PERIOD, DEFAULT_PERIOD.key);
    setSearchParams(searchParams, { replace: true });
  }, [period, searchParams, setSearchParams]);
  useEffect8(() => {
    if (gridId || !grid) return;
    searchParams.set(PARAMS_KEY_GRID_ID, grid.id);
    setSearchParams(searchParams, { replace: true });
  }, [grid, gridId, searchParams, setSearchParams]);
  return /* @__PURE__ */ jsxs37(
    "section",
    {
      "data-testid": "quality-monitoring-dashboard",
      className: "flex flex-col gap-4",
      children: [
        /* @__PURE__ */ jsx52(StatsContainer, {}),
        isPending && /* @__PURE__ */ jsx52(Loading10, {}),
        !isPending && /* @__PURE__ */ jsxs37(Fragment16, { children: [
          /* @__PURE__ */ jsxs37("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsx52(Heading113, { withOpacity: true, children: grid?.name }),
            /* @__PURE__ */ jsx52(FilterButton, { onClick: toggleFilters, disabled: isLoading })
          ] }),
          areFiltersOpen && /* @__PURE__ */ jsx52(Filters, {}),
          /* @__PURE__ */ jsx52(ChartsContainer, {})
        ] })
      ]
    }
  );
}

// src/pages/quality-monitoring-exchanges/index.tsx
import { useEntity as useEntity8 } from "@oppy/omniv2-entity";
import { Heading1 as Heading115, Table as Table4 } from "@oppy/omniv2-ui";
import { useQuery as useQuery8 } from "@tanstack/react-query";
import { useSearchParams as useSearchParams8 } from "react-router-dom";

// src/lib/services/quality-monitoring.service.ts
import { omniApiClient as omniApiClient4 } from "@oppy/omniv2-core";
import { simulateLatency } from "@oppy/omniv2-utils";
var buildQueryParams = function(searchParams) {
  const newSearchParams = new URLSearchParams(searchParams);
  const period = newSearchParams.get("period") || DEFAULT_PERIOD.key;
  const periodMap = COMPUTE_PERIODS_MAPPING[period]();
  if (!newSearchParams.get("pageNumber")) {
    newSearchParams.set("pageNumber", DEFAULT_PAGE_NUMBER.toString());
  }
  if (!newSearchParams.get("pageSize")) {
    newSearchParams.set("pageSize", DEFAULT_PAGE_SIZE.toString());
  }
  newSearchParams.set("startAt", formatDate2(periodMap.from, true));
  newSearchParams.set("endAt", formatDate2(periodMap.to, true));
  return newSearchParams.toString();
};
function searchQualityMonitoringEvaluations(entityId, searchParams) {
  const queryString = buildQueryParams(searchParams);
  return omniApiClient4.get(
    `${getBaseUrl(entityId)}evaluations/qualitymonitoring?${queryString}`
  );
}

// src/pages/quality-monitoring-exchanges/components/clearable-filters/index.tsx
import { Chip, faCalendarAlt, faMapMarkerAlt } from "@oppy/omniv2-ui";
import { useSearchParams as useSearchParams6 } from "react-router-dom";
import { jsx as jsx53, jsxs as jsxs38 } from "react/jsx-runtime";
var GRID_TYPE2 = "QualityMonitoring";
var PARAMS_KEY_GRID_IDS = "gridIds";
var PARAMS_KEY_PERIOD = "period";
function ClearableFilters({ isPending }) {
  const { openFilters, closeFilters } = useSearchStore();
  const [searchParams, setSearchParams] = useSearchParams6();
  const { data: grids } = useFetchGrids(GRID_TYPE2, {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const grid = grids?.find(
    (row) => row.id === searchParams.get(PARAMS_KEY_GRID_IDS)
  );
  const period = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get(PARAMS_KEY_PERIOD)
  ) || DEFAULT_PERIOD;
  return /* @__PURE__ */ jsxs38("div", { className: "flex flex-wrap gap-2 pl-0 md:pl-2", children: [
    grid && /* @__PURE__ */ jsx53(
      Chip,
      {
        clearable: true,
        onClear: () => {
          searchParams.delete(PARAMS_KEY_GRID_IDS);
          setSearchParams(searchParams, { replace: true });
          closeFilters();
        },
        leftIcon: faMapMarkerAlt,
        onClick: openFilters,
        children: grid.name
      }
    ),
    period && /* @__PURE__ */ jsx53(
      Chip,
      {
        clearable: false,
        onClear: void 0,
        leftIcon: faCalendarAlt,
        disabled: isPending,
        children: period.name
      }
    )
  ] });
}

// src/pages/quality-monitoring-exchanges/components/filters/index.tsx
import { Button as Button7, Heading1 as Heading114, Select as Select3 } from "@oppy/omniv2-ui";
import { useState as useState8 } from "react";
import { useSearchParams as useSearchParams7 } from "react-router-dom";
import { jsx as jsx54, jsxs as jsxs39 } from "react/jsx-runtime";
var GRID_TYPE3 = "QualityMonitoring";
var PARAMS_KEY_GRID_IDS2 = "gridIds";
var PARAMS_KEY_PERIOD2 = "period";
var MOCKED_CENTRES = [];
var MOCKED_TEAMS = [];
var MOCKED_AGENTS = [];
function Filters2() {
  const [searchParams, setSearchParams] = useSearchParams7();
  const { toggleFilters } = useSearchStore();
  const { data: grids, isPending: isGridsPending } = useFetchGrids(GRID_TYPE3, {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const gridId = searchParams.get(PARAMS_KEY_GRID_IDS2);
  const selectedGrid = grids?.find((grid) => grid.id === gridId);
  const selectedPeriod = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get(PARAMS_KEY_PERIOD2)
  );
  const [tempGrid, setTempGrid] = useState8(selectedGrid);
  const [tempPeriod, setTempPeriod] = useState8(
    selectedPeriod || DEFAULT_PERIOD
  );
  const [tempCentre, setTempCentre] = useState8();
  const [tempTeam, setTempTeam] = useState8();
  const [tempAgent, setTempAgent] = useState8();
  return /* @__PURE__ */ jsxs39(Section, { className: "mb-5 flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx54(Heading114, { children: "Filtres" }),
    /* @__PURE__ */ jsx54("hr", {}),
    /* @__PURE__ */ jsxs39("div", { className: "flex flex-col gap-4 lg:flex-row lg:items-center", children: [
      /* @__PURE__ */ jsx54(
        Select3,
        {
          value: tempGrid,
          onChange: (event) => setTempGrid(event.value),
          options: grids,
          optionLabel: "name",
          placeholder: "Grille",
          disabled: isGridsPending
        }
      ),
      /* @__PURE__ */ jsx54(
        Select3,
        {
          value: tempPeriod,
          onChange: (event) => setTempPeriod(event.value),
          options: SEARCH_PERIODS,
          optionLabel: "name",
          placeholder: "P\xE9riode",
          disabled: isGridsPending
        }
      ),
      /* @__PURE__ */ jsx54(
        Select3,
        {
          value: tempCentre,
          onChange: (event) => setTempCentre(event.value),
          options: MOCKED_CENTRES,
          optionLabel: "name",
          placeholder: "Centre",
          disabled: isGridsPending
        }
      ),
      /* @__PURE__ */ jsx54(
        Select3,
        {
          value: tempTeam,
          onChange: (event) => setTempTeam(event.value),
          options: MOCKED_TEAMS,
          optionLabel: "name",
          placeholder: "\xC9quipe",
          disabled: isGridsPending
        }
      ),
      /* @__PURE__ */ jsx54(
        Select3,
        {
          value: tempAgent,
          onChange: (event) => setTempAgent(event.value),
          options: MOCKED_AGENTS,
          optionLabel: "name",
          placeholder: "Agent",
          disabled: isGridsPending
        }
      )
    ] }),
    /* @__PURE__ */ jsxs39("div", { className: "flex flex-col items-center justify-center gap-4 md:flex-row", children: [
      /* @__PURE__ */ jsx54(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "text-xs",
          onClick: () => {
            setSearchParams({ period: DEFAULT_PERIOD.key }, { replace: true });
            toggleFilters();
            localStorage.removeItem("qm-filters");
          },
          children: "R\xE9initialiser les filtres"
        }
      ),
      /* @__PURE__ */ jsx54(
        Button7,
        {
          onClick: () => {
            if (tempGrid) searchParams.set("gridIds", tempGrid.id);
            if (tempPeriod) searchParams.set("period", tempPeriod.key);
            if (tempCentre) searchParams.set("centre", tempCentre.name);
            if (tempTeam) searchParams.set("team", tempTeam.name);
            if (tempAgent) searchParams.set("agent", tempAgent.name);
            setSearchParams(searchParams, { replace: true });
            toggleFilters();
            localStorage.setItem("qm-filters", searchParams.toString());
          },
          children: "Rechercher"
        }
      )
    ] })
  ] });
}

// src/pages/quality-monitoring-exchanges/quality-monitoring-exchanges.config.tsx
import { AppLink as AppLink5, Badge as Badge2, faCheck as faCheck3, faTimes as faTimes5, Icon as Icon16 } from "@oppy/omniv2-ui";
import { formatDate as formatDate3 } from "@oppy/omniv2-utils";
import { jsx as jsx55, jsxs as jsxs40 } from "react/jsx-runtime";
var COLUMNS = [
  {
    field: "status",
    header: "",
    body: ({ status = "Unknown" }) => /* @__PURE__ */ jsx55(
      Icon16,
      {
        icon: ICON_STATUS_MAPPING[status],
        className: COLOR_STATUS_MAPPING[status],
        title: STATUS_TITLE_MAPPING[status]
      }
    )
  },
  {
    field: "date",
    header: "Date d'appel",
    body: ({ callDate }) => formatDate3(callDate),
    sortable: true
  },
  {
    field: "objective",
    header: "Objectif",
    body: ({ isObjectiveReached }) => {
      if (isObjectiveReached === null) {
        return "N/A";
      }
      const icon = isObjectiveReached ? faCheck3 : faTimes5;
      const variant = isObjectiveReached ? "success" : "error";
      return /* @__PURE__ */ jsxs40(Badge2, { variant, children: [
        /* @__PURE__ */ jsx55(Icon16, { icon }),
        " ",
        isObjectiveReached ? "oui" : "non"
      ] });
    },
    sortable: true
  },
  {
    field: "rate",
    header: "Taux",
    body: (evaluation) => {
      if (evaluation.score === null || evaluation.maxScore === null) {
        return "N/A";
      }
      const ratePercentage = getRateInPercentFromEvaluation(evaluation);
      let variant;
      if (ratePercentage > 60) variant = "success";
      else if (ratePercentage > 25) variant = "warning";
      else variant = "error";
      return /* @__PURE__ */ jsxs40(Badge2, { variant, children: [
        ratePercentage.toFixed(2),
        "%"
      ] });
    }
  },
  { field: "centre", header: "Centre", body: () => "N/A" },
  { field: "team", header: "\xC9quipe", body: () => "N/A" },
  { field: "agent", header: "Agent", body: () => "N/A" },
  {
    field: "duration",
    header: "Dur\xE9e",
    body: ({ evaluatedCallId, fileDurationInSeconds }) => {
      const minutes = Math.floor(fileDurationInSeconds / 60);
      const secondes = Math.floor(fileDurationInSeconds - minutes * 60);
      return /* @__PURE__ */ jsxs40("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx55(PlaySoundButton, { evaluatedCallId }),
        minutes.toString().padStart(2, "0"),
        ":",
        secondes.toString().padStart(2, "0")
      ] });
    }
  },
  {
    field: "evaluatedCallId",
    header: "ID",
    align: "right",
    body: ({ evaluatedCallId, status }) => {
      if (status !== "EvaluationSucceeded") return null;
      return /* @__PURE__ */ jsx55(
        AppLink5,
        {
          to: `/quality-monitoring/exchanges/details/${evaluatedCallId}`,
          className: "text-base font-light text-primary underline transition-all hover:text-primary/50",
          children: evaluatedCallId.slice(0, EVAL_ID_MAX_CHARS)
        }
      );
    }
  }
];

// src/pages/quality-monitoring-exchanges/index.tsx
import { Fragment as Fragment17, jsx as jsx56, jsxs as jsxs41 } from "react/jsx-runtime";
var GRID_TYPE4 = "QualityMonitoring";
function QualityMonitoringExchanges() {
  const { entityId } = useEntity8();
  const [searchParams, setSearchParams] = useSearchParams8();
  const { areFiltersOpen, toggleFilters } = useSearchStore();
  const { data: grids } = useFetchGrids(GRID_TYPE4, {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const grid = grids?.find((row) => row.id === searchParams.get("gridIds"));
  const filters = Object.fromEntries([...searchParams.entries()]);
  const pageNumber = +(searchParams.get("pageNumber") || DEFAULT_PAGE_NUMBER);
  const rowsPerPage = +(searchParams.get("pageSize") || DEFAULT_PAGE_SIZE);
  const { data, isPending } = useQuery8({
    queryKey: ["search-qm-activities", searchParams.toString()],
    queryFn: () => searchQualityMonitoringEvaluations(entityId, searchParams)
  });
  return /* @__PURE__ */ jsxs41(Fragment17, { children: [
    /* @__PURE__ */ jsxs41("div", { className: "mb-5 flex flex-col md:flex-row md:items-center md:justify-between", children: [
      /* @__PURE__ */ jsx56(Heading115, { className: "mb-2 md:mb-0", children: grid?.name ? grid.name : "Toutes les grilles" }),
      /* @__PURE__ */ jsxs41("div", { className: "flex flex-col items-start gap-4 md:flex-row md:items-center", children: [
        /* @__PURE__ */ jsx56(ClearableFilters, { isPending }),
        /* @__PURE__ */ jsx56(FilterButton, { onClick: toggleFilters, disabled: isPending })
      ] })
    ] }),
    areFiltersOpen && /* @__PURE__ */ jsx56(Filters2, {}),
    /* @__PURE__ */ jsx56(
      Table4,
      {
        columns: COLUMNS,
        value: data?.items || [],
        loading: isPending,
        onSort: (event) => {
          searchParams.set("orderBy", event.sortField);
          searchParams.set(
            "sortDirection",
            event.sortOrder === 1 ? "Ascending" : "Descending"
          );
          setSearchParams(searchParams, { replace: true });
        },
        onPage: (event) => {
          searchParams.set("pageNumber", ((event.page || 0) + 1).toString());
          setSearchParams(searchParams, { replace: true });
        },
        sortField: filters.orderBy,
        sortOrder: filters.sortDirection === "Ascending" ? 1 : -1,
        totalRecords: data?.totalItems,
        rows: rowsPerPage,
        first: pageNumber ? (+pageNumber - 1) * +(filters.pageSize || DEFAULT_PAGE_SIZE) : DEFAULT_PAGE_NUMBER,
        showTotalRecords: true
      }
    )
  ] });
}

// src/pages/sales-compliant-activity/index.tsx
import { useEntity as useEntity9 } from "@oppy/omniv2-entity";
import { Heading1 as Heading117, Table as Table5 } from "@oppy/omniv2-ui";
import { useQuery as useQuery9 } from "@tanstack/react-query";
import { useSearchParams as useSearchParams11 } from "react-router-dom";

// src/lib/services/sales-compliant.service.ts
import { omniApiClient as omniApiClient5 } from "@oppy/omniv2-core";
var buildQueryParams2 = function(searchParams) {
  const newSearchParams = new URLSearchParams(searchParams);
  const period = newSearchParams.get("period") || DEFAULT_PERIOD.key;
  const periodMap = COMPUTE_PERIODS_MAPPING[period]();
  if (!newSearchParams.get("pageNumber")) {
    newSearchParams.set("pageNumber", DEFAULT_PAGE_NUMBER.toString());
  }
  if (!newSearchParams.get("pageSize")) {
    newSearchParams.set("pageSize", DEFAULT_PAGE_SIZE.toString());
  }
  newSearchParams.set("startAt", formatDate2(periodMap.from, true));
  newSearchParams.set("endAt", formatDate2(periodMap.to, true));
  return newSearchParams.toString();
};
function searchSalesCompliantEvaluations(entityId, searchParams) {
  const queryString = buildQueryParams2(searchParams);
  return omniApiClient5.get(
    `${getBaseUrl(entityId)}evaluations/salescompliant?${queryString}`
  );
}

// src/pages/sales-compliant-activity/components/clearable-filters/index.tsx
import { Chip as Chip2, faCalendarAlt as faCalendarAlt2, faMapMarkerAlt as faMapMarkerAlt2 } from "@oppy/omniv2-ui";
import { useSearchParams as useSearchParams9 } from "react-router-dom";
import { jsx as jsx57, jsxs as jsxs42 } from "react/jsx-runtime";
var GRID_TYPE5 = "SalesCompliant";
var PARAMS_KEY_GRID_IDS3 = "gridIds";
var PARAMS_KEY_PERIOD3 = "period";
function ClearableFilters2({ isPending }) {
  const { openFilters, closeFilters } = useSearchStore();
  const [searchParams, setSearchParams] = useSearchParams9();
  const { data: grids } = useFetchGrids(GRID_TYPE5, {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const grid = grids?.find(
    (row) => row.id === searchParams.get(PARAMS_KEY_GRID_IDS3)
  );
  const period = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get(PARAMS_KEY_PERIOD3)
  ) || DEFAULT_PERIOD;
  return /* @__PURE__ */ jsxs42("div", { className: "flex flex-wrap gap-2 pl-0 md:pl-2", children: [
    grid && /* @__PURE__ */ jsx57(
      Chip2,
      {
        clearable: true,
        onClear: () => {
          searchParams.delete(PARAMS_KEY_GRID_IDS3);
          setSearchParams(searchParams, { replace: true });
          closeFilters();
        },
        leftIcon: faMapMarkerAlt2,
        onClick: openFilters,
        children: grid.name
      }
    ),
    period && /* @__PURE__ */ jsx57(
      Chip2,
      {
        clearable: false,
        onClear: void 0,
        leftIcon: faCalendarAlt2,
        disabled: isPending,
        children: period.name
      }
    )
  ] });
}

// src/pages/sales-compliant-activity/components/filters/index.tsx
import { Button as Button8, Heading1 as Heading116, Select as Select4 } from "@oppy/omniv2-ui";
import { useState as useState9 } from "react";
import { useSearchParams as useSearchParams10 } from "react-router-dom";
import { jsx as jsx58, jsxs as jsxs43 } from "react/jsx-runtime";
var GRID_TYPE6 = "SalesCompliant";
var PARAMS_KEY_GRID_IDS4 = "gridIds";
var PARAMS_KEY_PERIOD4 = "period";
function Filters3() {
  const [searchParams, setSearchParams] = useSearchParams10();
  const { toggleFilters } = useSearchStore();
  const { data: grids, isPending: isGridsPending } = useFetchGrids(GRID_TYPE6, {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const gridId = searchParams.get(PARAMS_KEY_GRID_IDS4);
  const selectedGrid = grids?.find((grid) => grid.id === gridId);
  const selectedPeriod = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get(PARAMS_KEY_PERIOD4)
  );
  const [tempGrid, setTempGrid] = useState9(selectedGrid);
  const [tempPeriod, setTempPeriod] = useState9(
    selectedPeriod || DEFAULT_PERIOD
  );
  return /* @__PURE__ */ jsxs43(Section, { className: "mb-5 flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx58(Heading116, { children: "Filtres" }),
    /* @__PURE__ */ jsx58("hr", {}),
    /* @__PURE__ */ jsxs43("div", { className: "flex flex-col gap-4 lg:flex-row lg:items-center", children: [
      /* @__PURE__ */ jsx58(
        Select4,
        {
          value: tempGrid,
          onChange: (event) => setTempGrid(event.value),
          options: grids,
          optionLabel: "name",
          placeholder: "Grille",
          disabled: isGridsPending
        }
      ),
      /* @__PURE__ */ jsx58(
        Select4,
        {
          value: tempPeriod,
          onChange: (event) => setTempPeriod(event.value),
          options: SEARCH_PERIODS,
          optionLabel: "name",
          placeholder: "P\xE9riode",
          disabled: isGridsPending
        }
      )
    ] }),
    /* @__PURE__ */ jsxs43("div", { className: "flex flex-col items-center justify-center gap-4 md:flex-row", children: [
      /* @__PURE__ */ jsx58(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "text-xs",
          onClick: () => {
            setSearchParams({ period: DEFAULT_PERIOD.key }, { replace: true });
            toggleFilters();
            localStorage.removeItem("sc-filters");
          },
          children: "R\xE9initialiser les filtres"
        }
      ),
      /* @__PURE__ */ jsx58(
        Button8,
        {
          onClick: () => {
            if (tempGrid) {
              searchParams.set("gridIds", tempGrid.id);
            }
            if (tempPeriod) {
              searchParams.set("period", tempPeriod.key);
            }
            setSearchParams(searchParams, { replace: true });
            toggleFilters();
            localStorage.setItem("sc-filters", searchParams.toString());
          },
          children: "Rechercher"
        }
      )
    ] })
  ] });
}

// src/pages/sales-compliant-activity/sales-compliant-activity.config.tsx
import { AppLink as AppLink6, Badge as Badge3, Icon as Icon17 } from "@oppy/omniv2-ui";
import { formatDate as formatDate4 } from "@oppy/omniv2-utils";
import { jsx as jsx59, jsxs as jsxs44 } from "react/jsx-runtime";
var COLUMNS2 = [
  {
    field: "status",
    header: "",
    body: ({ status = "Unknown" }) => /* @__PURE__ */ jsx59(
      Icon17,
      {
        icon: ICON_STATUS_MAPPING[status],
        className: COLOR_STATUS_MAPPING[status],
        title: STATUS_TITLE_MAPPING[status]
      }
    ),
    bodyClassName: "w-[40px]"
  },
  {
    field: "callDate",
    header: "Date d'appel",
    body: ({ callDate }) => formatDate4(callDate),
    sortable: true,
    bodyClassName: "w-[160px]"
  },
  {
    field: "gridName",
    header: "Nom de la grille",
    body: ({ gridName }) => /* @__PURE__ */ jsx59("p", { className: "overflow-hidden truncate pr-2", title: gridName, children: gridName }),
    bodyClassName: "max-w-[240px] overflow-hidden"
  },
  {
    field: "score",
    header: "Conforme",
    sortable: true,
    body: ({ score, maxScore }) => {
      if (!score || !maxScore) return "-";
      const percent = score * 100 / maxScore;
      let variant;
      if (percent === 0) {
        variant = "disabled";
      } else if (percent < 80) {
        variant = "error";
      } else if (percent < 100) {
        variant = "warning";
      } else {
        variant = "success";
      }
      return /* @__PURE__ */ jsxs44(Badge3, { variant, children: [
        percent.toFixed(2),
        "%"
      ] });
    },
    bodyClassName: "w-[120px]"
  },
  {
    field: "fileDurationInSeconds",
    header: "Dur\xE9e",
    body: ({ evaluatedCallId, fileDurationInSeconds }) => {
      const minutes = Math.floor(fileDurationInSeconds / 60);
      const secondes = Math.floor(fileDurationInSeconds - minutes * 60);
      return /* @__PURE__ */ jsxs44("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx59(PlaySoundButton, { evaluatedCallId }),
        minutes.toString().padStart(2, "0"),
        ":",
        secondes.toString().padStart(2, "0")
      ] });
    },
    bodyClassName: "w-[90px]"
  },
  {
    field: "evaluatedCallId",
    header: "ID",
    align: "right",
    body: ({ evaluatedCallId, status }) => {
      if (status !== "EvaluationSucceeded") return null;
      return /* @__PURE__ */ jsx59(
        AppLink6,
        {
          to: `/sales-compliant/exchanges/details/${evaluatedCallId}`,
          className: "text-base font-light text-primary underline transition-all hover:text-primary/50",
          children: evaluatedCallId.slice(0, EVAL_ID_MAX_CHARS)
        }
      );
    },
    bodyClassName: "w-[70px]"
  }
];

// src/pages/sales-compliant-activity/index.tsx
import { Fragment as Fragment18, jsx as jsx60, jsxs as jsxs45 } from "react/jsx-runtime";
function SalesCompliantActivity() {
  const { entityId } = useEntity9();
  const [searchParams, setSearchParams] = useSearchParams11();
  const { areFiltersOpen, toggleFilters } = useSearchStore();
  const { data: grids } = useFetchGrids("SalesCompliant", {
    orderBy: "CreatedAt",
    sortDirection: "Descending",
    isActive: true
  });
  const rowsPerPage = +(searchParams.get("pageSize") || DEFAULT_PAGE_SIZE);
  const grid = grids?.find((grid2) => grid2.id === searchParams.get("gridIds"));
  const filters = Object.fromEntries([...searchParams.entries()]);
  const pageNumber = +(searchParams.get("pageNumber") || DEFAULT_PAGE_NUMBER);
  const { data, isPending } = useQuery9({
    queryKey: ["search-sc-activities", searchParams.toString()],
    queryFn: () => searchSalesCompliantEvaluations(entityId, searchParams)
  });
  return /* @__PURE__ */ jsxs45(Fragment18, { children: [
    /* @__PURE__ */ jsxs45("div", { className: "mb-5 flex flex-col md:flex-row md:items-center md:justify-between", children: [
      /* @__PURE__ */ jsx60(Heading117, { className: "mb-2 md:mb-0", children: grid ? grid.name : "Toutes les grilles" }),
      /* @__PURE__ */ jsxs45("div", { className: "flex flex-col items-start gap-4 md:flex-row md:items-center", children: [
        /* @__PURE__ */ jsx60(ClearableFilters2, { isPending }),
        /* @__PURE__ */ jsx60(FilterButton, { onClick: toggleFilters, disabled: isPending })
      ] })
    ] }),
    areFiltersOpen && /* @__PURE__ */ jsx60(Filters3, {}),
    /* @__PURE__ */ jsx60(
      Table5,
      {
        columns: COLUMNS2,
        value: data?.items || [],
        loading: isPending,
        onSort: (event) => {
          searchParams.set("orderBy", event.sortField);
          searchParams.set(
            "sortDirection",
            event.sortOrder === 1 ? "Ascending" : "Descending"
          );
          setSearchParams(searchParams, { replace: true });
        },
        onPage: (event) => {
          searchParams.set("pageNumber", ((event.page || 0) + 1).toString());
          setSearchParams(searchParams, { replace: true });
        },
        sortField: filters.orderBy,
        sortOrder: filters.sortDirection === "Ascending" ? 1 : -1,
        totalRecords: data?.totalItems,
        rows: rowsPerPage,
        first: pageNumber ? (+pageNumber - 1) * +(filters.pageSize || DEFAULT_PAGE_SIZE) : DEFAULT_PAGE_NUMBER,
        showTotalRecords: true
      }
    )
  ] });
}

// src/pages/sales-compliant-dashboard/index.tsx
import { Heading1 as Heading123, Loading as Loading15 } from "@oppy/omniv2-ui";
import { useEffect as useEffect10 } from "react";
import { useSearchParams as useSearchParams14 } from "react-router-dom";

// src/pages/sales-compliant-dashboard/components/charts-container/index.tsx
import { useEntity as useEntity10 } from "@oppy/omniv2-entity";
import { useQuery as useQuery10 } from "@tanstack/react-query";
import { useSearchParams as useSearchParams12 } from "react-router-dom";

// src/pages/sales-compliant-dashboard/components/compliant-evaluation/index.tsx
import { Heading1 as Heading118, Loading as Loading11 } from "@oppy/omniv2-ui";

// src/pages/sales-compliant-dashboard/components/compliant-evaluation/compliant-evaluation.config.ts
import { formatDate as formatDate5 } from "@oppy/omniv2-utils";
function useData5() {
  const { isLoading, results } = useSalesCompliantStatsByGridStore();
  const years = results?.compliantSalesRateEvaluations.map((row) => formatDate5(row.date)) || [];
  const values = results?.compliantSalesRateEvaluations.map(
    (row) => row.compliantSalesPercentage
  ) || [];
  const chartProps = {
    labels: years,
    datasets: [{ label: "", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/sales-compliant-dashboard/components/compliant-evaluation/index.tsx
import { Fragment as Fragment19, jsx as jsx61, jsxs as jsxs46 } from "react/jsx-runtime";
function CompliantEvaluation() {
  const { isLoading, chartProps } = useData5();
  return /* @__PURE__ */ jsxs46(Fragment19, { children: [
    /* @__PURE__ */ jsx61(Heading118, { children: "Evaluation du taux de vente conforme" }),
    isLoading && /* @__PURE__ */ jsx61(Loading11, { centered: true }),
    chartProps && /* @__PURE__ */ jsx61("div", { className: "flex h-[90%] w-full items-center justify-center overflow-hidden", children: /* @__PURE__ */ jsx61(ChartBarPercent, { data: chartProps }) })
  ] });
}

// src/pages/sales-compliant-dashboard/components/conversion-funnel/index.tsx
import { Heading1 as Heading119, Loading as Loading12 } from "@oppy/omniv2-ui";

// src/pages/sales-compliant-dashboard/components/conversion-funnel-item/index.tsx
import { Fragment as Fragment20, jsx as jsx62, jsxs as jsxs47 } from "react/jsx-runtime";
function ConversionFunnelItem({ count, children }) {
  return /* @__PURE__ */ jsxs47(Fragment20, { children: [
    /* @__PURE__ */ jsx62("div", { className: "font-semibold", children }),
    /* @__PURE__ */ jsx62("div", { children: count })
  ] });
}

// src/pages/sales-compliant-dashboard/components/conversion-funnel/conversion-funnel.config.ts
import { formatDate as formatDate6 } from "@oppy/omniv2-utils";
function useData6() {
  const { isLoading, results } = useSalesCompliantStatsByGridStore();
  const conversionFunnel = results?.conversionFunnel;
  const dates = conversionFunnel?.statByDays.map(({ date }) => formatDate6(date)) || [];
  const listens = conversionFunnel?.statByDays.map(({ listensCount }) => listensCount) || [];
  const sales = conversionFunnel?.statByDays.map(({ salesCount }) => salesCount) || [];
  const compliants = conversionFunnel?.statByDays.map(
    ({ salesCompliantCount }) => salesCompliantCount
  ) || [];
  const data = {
    chart: {
      labels: dates,
      datasets: [
        { label: "Ecoutes", data: listens },
        { label: "Ventes", data: sales },
        { label: "Ventes conformes", data: compliants }
      ]
    },
    listenings: {
      count: conversionFunnel?.listensCount
    },
    sales: {
      count: conversionFunnel?.salesCount
    },
    compliantSales: {
      count: conversionFunnel?.compliantSalesCount
    }
  };
  return { isLoading, data: isLoading ? void 0 : data };
}

// src/pages/sales-compliant-dashboard/components/conversion-funnel/index.tsx
import { Fragment as Fragment21, jsx as jsx63, jsxs as jsxs48 } from "react/jsx-runtime";
function ConversionFunnel() {
  const { isLoading, data } = useData6();
  return /* @__PURE__ */ jsxs48(Fragment21, { children: [
    /* @__PURE__ */ jsx63(Heading119, { children: "Funnel de convertion" }),
    isLoading && /* @__PURE__ */ jsx63(Loading12, { centered: true }),
    data && /* @__PURE__ */ jsxs48(Fragment21, { children: [
      /* @__PURE__ */ jsx63("div", { className: "h-[70%] w-full overflow-hidden", children: /* @__PURE__ */ jsx63(ChartBar, { data: data.chart }) }),
      /* @__PURE__ */ jsxs48("div", { className: "flex flex-col gap-2 text-sm", children: [
        /* @__PURE__ */ jsx63("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx63(ConversionFunnelItem, { ...data.listenings, children: "Ecoutes" }) }),
        /* @__PURE__ */ jsx63("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx63(ConversionFunnelItem, { ...data.sales, children: "Ventes" }) }),
        /* @__PURE__ */ jsx63("div", { className: "flex justify-between", children: /* @__PURE__ */ jsx63(ConversionFunnelItem, { ...data.compliantSales, children: "Ventes conformes" }) })
      ] })
    ] })
  ] });
}

// src/pages/sales-compliant-dashboard/components/sales-distributions/index.tsx
import { Heading1 as Heading120, Loading as Loading13 } from "@oppy/omniv2-ui";

// src/pages/sales-compliant-dashboard/components/sales-distributions/sales-distributions.config.ts
function useData7() {
  const { isLoading, results } = useSalesCompliantStatsByGridStore();
  const labels = results?.salesDistributions?.map(({ categoryName }) => categoryName) || [];
  const values = results?.salesDistributions?.map(({ count }) => count) || [];
  const chartProps = {
    labels,
    datasets: [{ label: "R\xE9partition des ventes", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/sales-compliant-dashboard/components/sales-distributions/index.tsx
import { Fragment as Fragment22, jsx as jsx64, jsxs as jsxs49 } from "react/jsx-runtime";
function SalesDistributions() {
  const { isLoading, chartProps } = useData7();
  return /* @__PURE__ */ jsxs49(Fragment22, { children: [
    /* @__PURE__ */ jsx64(Heading120, { children: "R\xE9partition des ventes" }),
    isLoading && /* @__PURE__ */ jsx64(Loading13, { centered: true }),
    chartProps && /* @__PURE__ */ jsx64(ChartDoughnut, { data: chartProps })
  ] });
}

// src/pages/sales-compliant-dashboard/components/sales-performances/index.tsx
import { Heading1 as Heading121, Loading as Loading14 } from "@oppy/omniv2-ui";

// src/pages/sales-compliant-dashboard/components/sales-performances/sales-performances.config.ts
import { formatDate as formatDate7 } from "@oppy/omniv2-utils";
function useData8() {
  const { isLoading, results } = useSalesCompliantStatsByGridStore();
  const labels = results?.salesPerformances?.map(({ date }) => formatDate7(date)) || [];
  const values = results?.salesPerformances?.map(({ count }) => count) || [];
  const chartProps = {
    labels,
    datasets: [{ label: "", data: values }]
  };
  return { isLoading, chartProps: isLoading ? void 0 : chartProps };
}

// src/pages/sales-compliant-dashboard/components/sales-performances/index.tsx
import { Fragment as Fragment23, jsx as jsx65, jsxs as jsxs50 } from "react/jsx-runtime";
function SalesPerformances() {
  const { isLoading, chartProps } = useData8();
  return /* @__PURE__ */ jsxs50(Fragment23, { children: [
    /* @__PURE__ */ jsx65(Heading121, { children: "Evolution de vente" }),
    isLoading && /* @__PURE__ */ jsx65(Loading14, { centered: true }),
    chartProps && /* @__PURE__ */ jsx65(ChartLine, { data: chartProps })
  ] });
}

// src/pages/sales-compliant-dashboard/components/charts-container/index.tsx
import { jsx as jsx66, jsxs as jsxs51 } from "react/jsx-runtime";
function ChartsContainer2() {
  const { entityId } = useEntity10();
  const { setStats } = useSalesCompliantStatsByGridStore();
  const [searchParams] = useSearchParams12();
  useQuery10({
    queryKey: ["sales-compliant-stats", entityId, searchParams.toString()],
    queryFn: () => {
      getStatsForSalesCompliantByGridId(entityId, searchParams).then(setStats);
      return true;
    },
    enabled: searchParams.has("gridId")
  });
  return /* @__PURE__ */ jsxs51("div", { "data-testid": "charts-container", className: "grid grid-cols-12 gap-4", children: [
    /* @__PURE__ */ jsx66(Box, { className: "col-span-12 h-96 md:col-span-4", children: /* @__PURE__ */ jsx66(SalesDistributions, {}) }),
    /* @__PURE__ */ jsx66(Box, { className: "col-span-12 h-96 md:col-span-8", children: /* @__PURE__ */ jsx66(SalesPerformances, {}) }),
    /* @__PURE__ */ jsx66(Box, { className: "col-span-12 h-96 md:col-span-4", children: /* @__PURE__ */ jsx66(ConversionFunnel, {}) }),
    /* @__PURE__ */ jsx66(Box, { className: "col-span-12 h-96 md:col-span-8", children: /* @__PURE__ */ jsx66(CompliantEvaluation, {}) })
  ] });
}

// src/pages/sales-compliant-dashboard/components/filters/index.tsx
import { Button as Button9, Heading1 as Heading122, Select as Select5 } from "@oppy/omniv2-ui";
import { useEffect as useEffect9, useState as useState10 } from "react";
import { useSearchParams as useSearchParams13 } from "react-router-dom";
import { jsx as jsx67, jsxs as jsxs52 } from "react/jsx-runtime";
function Filters4() {
  const { isLoading, toggleFilters } = useSalesCompliantStatsByGridStore();
  const [searchParams, setSearchParams] = useSearchParams13();
  const { data: grids, isPending: isGridsPending } = useFetchGrids(
    "SalesCompliant",
    {
      orderBy: "CreatedAt",
      sortDirection: "Descending",
      isActive: true
    }
  );
  const gridId = searchParams.get("gridId");
  const selectedGrid = grids?.find((grid) => grid.id === gridId) || grids?.[0];
  const period = SEARCH_PERIODS.find(
    (row) => row.key === searchParams.get("period")
  );
  const [tempGrid, setTempGrid] = useState10(selectedGrid);
  const [tempPeriod, setTempPeriod] = useState10(
    period || DEFAULT_PERIOD
  );
  useEffect9(() => {
    if (isGridsPending) return;
    setTempGrid(selectedGrid);
  }, [isGridsPending, selectedGrid]);
  return /* @__PURE__ */ jsxs52(Section, { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ jsx67(Heading122, { children: "Filtres" }),
    /* @__PURE__ */ jsx67("hr", {}),
    /* @__PURE__ */ jsxs52("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ jsx67(
        Select5,
        {
          value: tempGrid,
          onChange: (event) => setTempGrid(event.value),
          options: grids,
          optionLabel: "name",
          placeholder: "Grille",
          disabled: isGridsPending || isLoading
        }
      ),
      /* @__PURE__ */ jsx67("div", { className: "h-full w-0.5 bg-slate-100", children: "\xA0" }),
      /* @__PURE__ */ jsx67("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx67(
        Select5,
        {
          value: tempPeriod,
          onChange: (event) => setTempPeriod(event.value),
          options: SEARCH_PERIODS,
          optionLabel: "name",
          placeholder: "P\xE9riode",
          disabled: isGridsPending || isLoading
        }
      ) })
    ] }),
    /* @__PURE__ */ jsxs52("div", { className: "flex items-center justify-center gap-4", children: [
      /* @__PURE__ */ jsx67(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "text-xs",
          onClick: () => {
            setSearchParams({}, { replace: true });
            toggleFilters();
          },
          children: "R\xE9initialiser les filtres"
        }
      ),
      /* @__PURE__ */ jsx67(
        Button9,
        {
          onClick: () => {
            if (tempGrid) {
              searchParams.set("gridId", tempGrid.id);
            }
            searchParams.set("period", tempPeriod.key);
            setSearchParams(searchParams, { replace: true });
            toggleFilters();
          },
          children: "Rechercher"
        }
      )
    ] })
  ] });
}

// src/pages/sales-compliant-dashboard/components/stats-container/index.tsx
import { useEntity as useEntity11 } from "@oppy/omniv2-entity";
import { useQuery as useQuery11 } from "@tanstack/react-query";

// src/lib/components/card-stats-enhanced/components/item/index.tsx
import { cn as cn10, CustomIcon as CustomIcon4 } from "@oppy/omniv2-ui";
import { jsx as jsx68, jsxs as jsxs53 } from "react/jsx-runtime";
function Items({ label, value, icon, className }) {
  return /* @__PURE__ */ jsxs53("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ jsx68(
      "div",
      {
        className: cn10(
          "size-10 bg-primary flex items-center justify-center rounded-lg shadow",
          className
        ),
        children: /* @__PURE__ */ jsx68(CustomIcon4, { name: icon, className: "text-white" })
      }
    ),
    /* @__PURE__ */ jsxs53("div", { children: [
      /* @__PURE__ */ jsx68("div", { className: "text-xs text-opacity-70", children: label }),
      /* @__PURE__ */ jsxs53("div", { className: "text-xl", children: [
        value,
        "%"
      ] })
    ] })
  ] });
}

// src/lib/components/card-stats-enhanced/index.tsx
import { jsx as jsx69, jsxs as jsxs54 } from "react/jsx-runtime";
var COLORS5 = ["bg-primary", "bg-success", "bg-warning"];
var ICON_MAPPING = ["INCREASE", "MENU", "THUMBS_UP_OUTLINE"];
function CardStatsEnhanced({ title, rows = [] }) {
  return /* @__PURE__ */ jsxs54(Box, { "data-testid": "card-stats", className: "min-h-36", children: [
    /* @__PURE__ */ jsx69("div", { "data-testid": "card-stats-title", className: "mb-5 font-semibold", children: title }),
    /* @__PURE__ */ jsx69("div", { className: "flex flex-wrap justify-between gap-2 sm:flex-row sm:flex-nowrap sm:items-center", children: rows.map((row, index) => /* @__PURE__ */ jsx69(
      Items,
      {
        label: row.name,
        value: row.percentage,
        icon: ICON_MAPPING[index],
        className: COLORS5[index]
      },
      row.name
    )) })
  ] });
}

// src/pages/sales-compliant-dashboard/components/stats-container/index.tsx
import { Fragment as Fragment24, jsx as jsx70, jsxs as jsxs55 } from "react/jsx-runtime";
function StatsContainer2() {
  const { entityId } = useEntity11();
  const { isLoading, data, isError } = useQuery11({
    queryKey: ["getForSalesCompliant", entityId],
    queryFn: () => getStatsForSalesCompliant(entityId),
    retry: false
  });
  if (isError) return null;
  return /* @__PURE__ */ jsxs55(
    "div",
    {
      "data-testid": "stats-container",
      className: "mt-10 grid grid-cols-12 gap-4",
      children: [
        isLoading && /* @__PURE__ */ jsxs55(Fragment24, { children: [
          /* @__PURE__ */ jsx70("div", { className: "col-span-3", children: /* @__PURE__ */ jsx70(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx70("div", { className: "col-span-3", children: /* @__PURE__ */ jsx70(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx70("div", { className: "col-span-3", children: /* @__PURE__ */ jsx70(CardStatsSkeleton, {}) }),
          /* @__PURE__ */ jsx70("div", { className: "col-span-3", children: /* @__PURE__ */ jsx70(CardStatsSkeleton, {}) })
        ] }),
        !isLoading && data && /* @__PURE__ */ jsxs55(Fragment24, { children: [
          /* @__PURE__ */ jsx70("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx70(
            CardStats,
            {
              title: "\xC9coutes",
              picto: "3d-woman-smartphone",
              percentEvolution: data.listensStats.evolutionPercentage,
              tag: "this-week",
              value: formatToKEuros(data.listensStats.listensCount, false)
            }
          ) }),
          /* @__PURE__ */ jsx70("div", { className: "col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3", children: /* @__PURE__ */ jsx70(
            CardStats,
            {
              title: "Ventes conformes",
              picto: "3d-man-coffee",
              percentEvolution: data.salesStats.evolutionPercentage,
              tag: "this-week",
              value: formatToKEuros(data.salesStats.count, false)
            }
          ) }),
          /* @__PURE__ */ jsx70("div", { className: "col-span-12 lg:col-span-6", children: /* @__PURE__ */ jsx70(CardStatsEnhanced, { title: "Conformit\xE9", rows: data.compliantsStats }) })
        ] })
      ]
    }
  );
}

// src/pages/sales-compliant-dashboard/index.tsx
import { Fragment as Fragment25, jsx as jsx71, jsxs as jsxs56 } from "react/jsx-runtime";
var GRID_TYPE7 = "SalesCompliant";
var PARAMS_KEY_GRID_ID2 = "gridId";
var PERIOD_KEY_PERIOD2 = "period";
function SalesCompliantDashboard() {
  const [searchParams, setSearchParams] = useSearchParams14();
  const gridId = searchParams.get(PARAMS_KEY_GRID_ID2);
  const period = searchParams.get(PERIOD_KEY_PERIOD2);
  const { data: grids, isPending } = useFetchGrids(GRID_TYPE7);
  const activeGrids = grids?.filter((a) => a.isActive);
  const grid = activeGrids?.find((grid2) => grid2.id === gridId) || activeGrids?.[0];
  const { areFiltersOpen, toggleFilters } = useSalesCompliantStatsByGridStore();
  useEffect10(() => {
    if (period) return;
    searchParams.set(PERIOD_KEY_PERIOD2, DEFAULT_PERIOD.key);
    setSearchParams(searchParams);
  }, [period, searchParams, setSearchParams]);
  useEffect10(() => {
    if (gridId || !grid) return;
    searchParams.set(PARAMS_KEY_GRID_ID2, grid.id);
    setSearchParams(searchParams);
  }, [grid, gridId, searchParams, setSearchParams]);
  return /* @__PURE__ */ jsxs56(
    "section",
    {
      "data-testid": "sales-compliant-dashboard",
      className: "flex flex-col gap-4",
      children: [
        /* @__PURE__ */ jsx71(StatsContainer2, {}),
        isPending && /* @__PURE__ */ jsx71(Loading15, {}),
        !isPending && /* @__PURE__ */ jsxs56(Fragment25, { children: [
          /* @__PURE__ */ jsxs56("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsx71(Heading123, { withOpacity: true, children: grid?.name }),
            /* @__PURE__ */ jsx71(FilterButton, { onClick: toggleFilters })
          ] }),
          areFiltersOpen && /* @__PURE__ */ jsx71(Filters4, {}),
          /* @__PURE__ */ jsx71(ChartsContainer2, {})
        ] })
      ]
    }
  );
}

// src/lib/components/dialog-wrapper/index.tsx
import { Dialog as Dialog2 } from "@oppy/omniv2-ui";

// src/lib/components/dialog-wrapper/dialogs.config.ts
var DIALOG_MAPPINGS = {
  // 'import-audio': lazy(() => import('./components/import-audio')),
};

// src/lib/components/dialog-wrapper/index.tsx
import { jsx as jsx72 } from "react/jsx-runtime";
function DialogWrapper() {
  const { type, title, dialogProps, closeDialog } = useDialogStore();
  const Component = type && DIALOG_MAPPINGS[type];
  const isVisible = !!type && !!Component;
  return /* @__PURE__ */ jsx72(
    Dialog2,
    {
      header: title,
      visible: isVisible,
      draggable: false,
      onHide: closeDialog,
      className: "md:w-[50vw]",
      pt: {
        root: {
          className: "rounded-lg shadow-lg border-0 bg-white w-[90vw] md:w-[50vw] md:maw-w-[1440px]"
        },
        header: {
          className: "font-bold p-5 flex items-center"
        },
        content: { className: "pt-0 p-5" },
        mask: { className: "bg-black/40" }
      },
      children: Component && /* @__PURE__ */ jsx72(Component, { ...dialogProps })
    }
  );
}

// src/lib/core/providers.tsx
import { Outlet } from "react-router-dom";
import { jsx as jsx73, jsxs as jsxs57 } from "react/jsx-runtime";
function Providers() {
  return /* @__PURE__ */ jsxs57("div", { className: "mx-auto w-full max-w-[1440px]", children: [
    /* @__PURE__ */ jsx73(DialogWrapper, {}),
    /* @__PURE__ */ jsx73(Outlet, {})
  ] });
}

// src/lib/core/routes/index.tsx
import { jsx as jsx74 } from "react/jsx-runtime";
var routes = [
  {
    index: true,
    loader: ({ params: { entityId } }) => redirect(`/${entityId}/sales-compliant/dashboard`)
  },
  {
    id: "sales-compliant",
    path: "sales-compliant",
    element: /* @__PURE__ */ jsx74(
      RouteGuard,
      {
        resource: RESOURCES.SALES_COMPLIANT,
        permission: PERMISSIONS.ACCESS,
        children: /* @__PURE__ */ jsx74(Providers, {})
      }
    ),
    children: [
      {
        id: "sales-dashboard",
        path: "dashboard",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.SALES_COMPLIANT,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(SalesCompliantDashboard, {})
          }
        )
      },
      {
        id: "sales-activity",
        path: "sales-activity",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.SALES_COMPLIANT,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(SalesCompliantActivity, {})
          }
        )
      },
      {
        id: "sales-exchanges",
        path: "exchanges/details/:id",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.SALES_COMPLIANT,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(ExchangeDetails, {})
          }
        )
      },
      {
        id: "sales-settings",
        path: "settings",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.SALES_COMPLIANT,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(GridsManagement, { gridType: "SalesCompliant" })
          }
        )
      },
      {
        path: "new-grid",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.SALES_COMPLIANT,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(NewGrid, { gridType: "SalesCompliant" })
          }
        )
      }
    ]
  },
  {
    id: "quality-monitoring",
    path: "quality-monitoring",
    element: /* @__PURE__ */ jsx74(
      RouteGuard,
      {
        resource: RESOURCES.QUALITY_MONITORING,
        permission: PERMISSIONS.ACCESS,
        children: /* @__PURE__ */ jsx74(Providers, {})
      }
    ),
    children: [
      {
        id: "quality-dashboard",
        path: "dashboard",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.QUALITY_MONITORING,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(QualityMonitoringDashboard, {})
          }
        )
      },
      {
        id: "quality-exchanges",
        path: "exchanges",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.QUALITY_MONITORING,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(QualityMonitoringExchanges, {})
          }
        )
      },
      {
        path: "exchanges/details/:id",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.QUALITY_MONITORING,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(ExchangeDetails, {})
          }
        )
      },
      {
        id: "quality-settings",
        path: "settings",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.QUALITY_MONITORING,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(GridsManagement, { gridType: "QualityMonitoring" })
          }
        )
      },
      {
        path: "new-grid",
        element: /* @__PURE__ */ jsx74(
          RouteGuard,
          {
            resource: RESOURCES.QUALITY_MONITORING,
            permission: PERMISSIONS.ACCESS,
            children: /* @__PURE__ */ jsx74(NewGrid, { gridType: "QualityMonitoring" })
          }
        )
      }
    ]
  }
];
var routes_default = routes;
export {
  navigations_default as navigations,
  routes_default as routes
};
